import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class FreezeFrame implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES:
        ' 62 04 39 06 00 07 00 73 13 1E 00 04 04 04 04 01 01 23 00 00 00 F6 04 0A 5C 00 70 02 00 00 04 04 04 04 01 01 F6 04 00 00 19 00 00 05 02 70 02 00 00 04 04 04 04 01 01 F6 04 00 00 18 00 00 5C 00 70 02 00 00 04 04 04 04 01 01 F6 04 00 00 18 00 00 5C 00 70 02 00 00 04 04 04 04 01 01 F6 04 00 00 19 00 00 5C 00 71 02 00 00 04 04 04 04 01 01 23 00 00 00 1A 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.FreezeFrame,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'FreezeFrame',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_Entri',
              unit: '',
              translationid: 'TI_Entries',
              dopname: '2 Byte Identical uint16',
              name: 'PA_Entri',
              value: '6',
            },
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_FreezFrame',
              translationid: 'TI_FreezeFrame',
              dopname: 'EOPF Structure DTCErrorFreezeFrame',
              name: 'PA_FreezFrame',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'InterruptionDomesticHotWaterSensor',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Active',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Error',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'Active',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'HeatingDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '3.5',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '127.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '10',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'FailureCommunicationAdioModule',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Error',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'RampUp',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '127.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '2.5',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'FailureCommunicationWiredRemoteControl',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Error',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'RampUp',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '127.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '2.4',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'FailureCommunicationAdioModule',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Error',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'RampUp',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '127.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '2.4',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'FailureCommunicationAdioModule',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Error',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'RampUp',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '127.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '2.5',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'FailureCommunicationAdioModule',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Startup',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Error',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'RampUp',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'FixValue',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'Yes',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '3.5',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '2.6',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'NoErrorAvailable',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'NoErrorAvailable',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'NoErrorAvailable',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                  translationid: '',
                  dopname: 'Structure FreezeFrameGenericHmu',
                  name: 'STR_StrucFreezFrameGenerHmu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcError',
                      dopname: '2 Byte TextTable DTCError',
                      name: 'PA_DTC',
                      value: 'NoErrorAvailable',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                      unit: '',
                      translationid: 'TI_HeatEngineStatus',
                      dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                      name: 'PA_HeatEnginStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                      unit: '',
                      translationid: 'TI_FuelCellStatus',
                      dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                      name: 'PA_FuelCellStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                      unit: '',
                      translationid: 'TI_BoilerControllerStatus',
                      dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                      name: 'PA_BoileContrStatu',
                      value: 'Standby',
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                      unit: '',
                      translationid: 'TI_ProductionManager',
                      dopname: '4 Bit TextTable FreezeFrameProductionManager',
                      name: 'PA_ProduManag',
                      value: 'NoDemand',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                      translationid: 'TI_DemandManagerRequestsPartOne',
                      dopname: '8 Bit Structure DemandManagerRequestPartOne',
                      name: 'PA_DemanManagRequePartOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DomesHotWater',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_HeatiCircuFour',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                          unit: '',
                          translationid: 'TI_DigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_DigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_DigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                          unit: '',
                          translationid: 'TI_AutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_AutomGateWay',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                      translationid: 'TI_DemandManagerRequestsPartTwo',
                      dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                      name: 'PA_DemanManagRequePartTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                          unit: '',
                          translationid: 'TI_LockDigitalInput',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInput',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                          unit: '',
                          translationid: 'TI_LockDigitalInputOutputBoard',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockDigitInputOutpuBoard',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                          unit: '',
                          translationid: 'TI_LockAutomationGateWay',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LockAutomGateWay',
                          value: 'No',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                          unit: '',
                          translationid: 'TI_Reserved',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                      translationid: 'TI_HeatingCircuitOne',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuOne',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                      translationid: 'TI_HeatingCircuitTwo',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuTwo',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                      translationid: 'TI_HeatingCircuitThree',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuThree',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                      translationid: 'TI_HeatingCircuitFour',
                      dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                      name: 'PA_HeatiCircuFour',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                          unit: '',
                          translationid: '',
                          dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                          name: 'PA_HeatiCircuCurreState',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                          unit: '',
                          translationid: 'TI_FunctionOne',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctOne',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctTwo',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                          unit: '',
                          translationid: 'TI_Level',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctThree',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_FunctFour',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                      translationid: 'TI_DomesticHotWater',
                      dopname: '8 Bit Structure DomesticHotWater',
                      name: 'PA_DomesHotWater',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                          unit: '',
                          translationid: 'TI_LegionellaActive',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_LegioActiv',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                          unit: '',
                          translationid: 'TI_CirculationPump',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_CircuPump',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                          unit: '',
                          translationid: 'TI_FunctionTwo',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_DomesHotWaterActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                      translationid: 'TI_Solar',
                      dopname: '8 Bit Structure Solar',
                      name: 'PA_Solar',
                      structure: [
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                          unit: '',
                          translationid: 'TI_Mode',
                          dopname: '1 Bit TextTable NoYes',
                          name: 'PA_Mode',
                          value: 'No',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                          unit: '',
                          translationid: 'TI_PumpActive',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_PumpActiv',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                          unit: '',
                          translationid: 'TI_SuppressionDomesticHotWater',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprDomesHotWater',
                          value: 'Off',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                          unit: '',
                          translationid: 'TI_SuppressionCentralHeating',
                          dopname: '1 Bit TextTable OffOn',
                          name: 'PA_SupprCentrHeati',
                          value: 'Off',
                        },
                        {
                          semantic: 'RESERVED',
                          path:
                            'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                          unit: '',
                          translationid: '',
                          dopname: '',
                          name: 'PA_Reser',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                      unit: '°C',
                      translationid: 'TI_FlowTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_FlowTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                      unit: '°C',
                      translationid: 'TI_OutsideTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_OutsiTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                      unit: '°C',
                      translationid: 'TI_DomesticHotWaterTemperatureSensor',
                      dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                      name: 'PA_DomesHotWaterTempeSenso',
                      value: '0.0',
                    },
                    {
                      semantic: 'VALUE',
                      path:
                        'PA_DataRecor/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                      unit: '%',
                      translationid: 'TI_PrimaryCircuitPumpSpeed',
                      dopname: '1 Byte Identical uint8 Percent',
                      name: 'PA_PrimaCircuPumpSpeed',
                      value: '0',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 04 39',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.FreezeFrame,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '1081',
          value: 'FreezeFrame',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.FreezeFrame,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '1081',
              value: 'FreezeFrame',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ENTRIES',
                  longname: 'Entries',
                  byteposition: '0',
                  dopname: '2 Byte Identical uint16',
                  precision: '',
                  byteLength: '16',
                  type: 'eA_UINT32',
                  shortname: 'PA_Entri',
                  constraints: '[0:65535]',
                  path: 'PA_Struc/PA_Entri',
                  unit: '',
                  translationid: 'TI_Entries',
                  bitposition: '0',
                  name: 'PA_Entri',
                  value: '0',
                },
                {
                  semantic: 'VALUE',
                  longname: 'FreezeFrame',
                  byteposition: '2',
                  dopname: 'EOPF Structure DTCErrorFreezeFrame',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_FreezFrame',
                  constraints: '[1:32767]',
                  structure: [
                    {
                      semantic: '',
                      longname: 'Structure FreezeFrameGenericHmu',
                      byteposition: '-1',
                      dopname: 'Structure FreezeFrameGenericHmu',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_StrucFreezFrameGenerHmu',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'FAULTREAD',
                          longname: 'DTC',
                          byteposition: '0',
                          dopname: '2 Byte TextTable DTCError',
                          precision: '',
                          byteLength: '16',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DTC',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_F_0',
                              interval: '0',
                              texttableentry: 'NoErrorAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_1',
                              interval: '1',
                              texttableentry: 'InterruptionFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_2',
                              interval: '2',
                              texttableentry: 'ShortCircuitFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_3',
                              interval: '3',
                              texttableentry: 'InterruptionReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_4',
                              interval: '4',
                              texttableentry: 'ShortCircuitReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_5',
                              interval: '5',
                              texttableentry: 'InterruptionWaterFlowSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_6',
                              interval: '6',
                              texttableentry: 'ShortCircuitWaterFlowSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_7',
                              interval: '7',
                              texttableentry: 'InterruptionDomesticHotWaterSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_8',
                              interval: '8',
                              texttableentry: 'ShortCircuitDomesticHotWaterSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_9',
                              interval: '9',
                              texttableentry: 'InterruptionDomesticHotWaterFlowSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_10',
                              interval: '10',
                              texttableentry: 'ShortCircuitDomesticHotWaterFlowSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_11',
                              interval: '11',
                              texttableentry: 'InterruptionSolarRoofSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_12',
                              interval: '12',
                              texttableentry: 'ShortCircuitSolarRoofSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_13',
                              interval: '13',
                              texttableentry: 'InterruptionOutsideTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_14',
                              interval: '14',
                              texttableentry: 'ShortCircuitOutsideTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_15',
                              interval: '15',
                              texttableentry: 'InterruptionSolarBottomSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_16',
                              interval: '16',
                              texttableentry: 'ShortCircuitSolarBottomSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_17',
                              interval: '17',
                              texttableentry: 'InterruptionSolarTopSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_18',
                              interval: '18',
                              texttableentry: 'ShortCircuitSolarTopSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_19',
                              interval: '19',
                              texttableentry: 'InterruptionBufferBottomSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_20',
                              interval: '20',
                              texttableentry: 'ShortCircuitBufferBottomSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_21',
                              interval: '21',
                              texttableentry: 'InterruptionBufferMidBottomSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_22',
                              interval: '22',
                              texttableentry: 'ShortCircuitBufferMidBottomSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_23',
                              interval: '23',
                              texttableentry: 'InterruptionBufferMidSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_24',
                              interval: '24',
                              texttableentry: 'ShortCircuitBufferMidSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_25',
                              interval: '25',
                              texttableentry: 'InterruptionBufferMidTopSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_26',
                              interval: '26',
                              texttableentry: 'ShortCircuitBufferMidTopSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_27',
                              interval: '27',
                              texttableentry: 'InterruptionBufferTopSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_28',
                              interval: '28',
                              texttableentry: 'ShortCircuitBufferTopSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_29',
                              interval: '29',
                              texttableentry: 'InterruptionLowLossTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_30',
                              interval: '30',
                              texttableentry: 'ShortCircuitLowLossTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_31',
                              interval: '31',
                              texttableentry: 'InterruptionMixerHeatingCircuitSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_32',
                              interval: '32',
                              texttableentry: 'ShortCircuitMixerHeatingCircuitSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_33',
                              interval: '33',
                              texttableentry: 'InterruptionPrimaryInletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_34',
                              interval: '34',
                              texttableentry: 'ShortCircuitPrimaryInletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_35',
                              interval: '35',
                              texttableentry: 'InterruptionBrineOutletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_36',
                              interval: '36',
                              texttableentry: 'ShortCircuitBrineOutletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_37',
                              interval: '37',
                              texttableentry: 'InterruptionWaterPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_38',
                              interval: '38',
                              texttableentry: 'ShortCircuitWaterPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_39',
                              interval: '39',
                              texttableentry: 'InterruptionBrinePresssureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_40',
                              interval: '40',
                              texttableentry: 'ShortCircuitBrinePressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_41',
                              interval: '41',
                              texttableentry: 'InterruptionOutsideSupplyAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_42',
                              interval: '42',
                              texttableentry: 'ShortCircuitOutsideSupplyAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_43',
                              interval: '43',
                              texttableentry: 'InterruptionIncomingAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_44',
                              interval: '44',
                              texttableentry: 'ShortCircuitIncomingAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_45',
                              interval: '45',
                              texttableentry: 'InterruptionOutcomingAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_46',
                              interval: '46',
                              texttableentry: 'ShortCircuitOutcomingAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_47',
                              interval: '47',
                              texttableentry: 'InterruptionUsedAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_48',
                              interval: '48',
                              texttableentry: 'ShortCircuitUsedAirTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_49',
                              interval: '49',
                              texttableentry: 'InterruptionFlueGasTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_50',
                              interval: '50',
                              texttableentry: 'ShortCircuitFlueGasTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_51',
                              interval: '51',
                              texttableentry: 'InterruptionFlowOneSensorOrSwitch',
                            },
                            {
                              TI_texttableentry: 'TI_F_52',
                              interval: '52',
                              texttableentry: 'ShortCircuitFlowOneSensorOrSwitch',
                            },
                            {
                              TI_texttableentry: 'TI_F_53',
                              interval: '53',
                              texttableentry: 'InterruptionFlowTwoSensorOrSwitch',
                            },
                            {
                              TI_texttableentry: 'TI_F_54',
                              interval: '54',
                              texttableentry: 'ShortCircuitFlowTwoSensorOrSwitch',
                            },
                            {
                              TI_texttableentry: 'TI_F_55',
                              interval: '55',
                              texttableentry: 'InterruptionCoSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_56',
                              interval: '56',
                              texttableentry: 'ShortCiruitCoSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_57',
                              interval: '57',
                              texttableentry: 'InterruptionRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_58',
                              interval: '58',
                              texttableentry: 'ShortCircuitRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_59',
                              interval: '59',
                              texttableentry: 'PowerSupplyLowVoltageDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_60',
                              interval: '60',
                              texttableentry: 'PowerSupplyOverloadDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_61',
                              interval: '61',
                              texttableentry: 'FailureInternalPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_62',
                              interval: '62',
                              texttableentry: 'OverHeatingProtectionSafetyTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_63',
                              interval: '63',
                              texttableentry: 'OverHeatingProtectionFlueGasSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_64',
                              interval: '64',
                              texttableentry: 'FlameLostDuringOperation',
                            },
                            {
                              TI_texttableentry: 'TI_F_65',
                              interval: '65',
                              texttableentry: 'NoFlameDuringStarting',
                            },
                            {
                              TI_texttableentry: 'TI_F_66',
                              interval: '66',
                              texttableentry: 'DefectIgnitor',
                            },
                            {
                              TI_texttableentry: 'TI_F_67',
                              interval: '67',
                              texttableentry: 'FailureIoniSignal',
                            },
                            {
                              TI_texttableentry: 'TI_F_68',
                              interval: '68',
                              texttableentry: 'FailureExtraneousLight',
                            },
                            {
                              TI_texttableentry: 'TI_F_69',
                              interval: '69',
                              texttableentry: 'FailureElectronicAirGasRatioSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_70',
                              interval: '70',
                              texttableentry: 'FailureInternalBurnerControlSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_71',
                              interval: '71',
                              texttableentry: 'FailureTargetFanSpeedNotAchieved',
                            },
                            {
                              TI_texttableentry: 'TI_F_72',
                              interval: '72',
                              texttableentry: 'FailureZeroFanSpeedNotAchieved',
                            },
                            {
                              TI_texttableentry: 'TI_F_73',
                              interval: '73',
                              texttableentry: 'InternalCommunicationError',
                            },
                            {
                              TI_texttableentry: 'TI_F_74',
                              interval: '74',
                              texttableentry: 'WaterPressureTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_75',
                              interval: '75',
                              texttableentry: 'NoWaterFlowDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_76',
                              interval: '76',
                              texttableentry: 'NoValidViessmannIdentificationNumberAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_77',
                              interval: '77',
                              texttableentry: 'FailurePersistentMemory',
                            },
                            {
                              TI_texttableentry: 'TI_F_78',
                              interval: '78',
                              texttableentry: 'FailureHmiCommunication',
                            },
                            {
                              TI_texttableentry: 'TI_F_79',
                              interval: '79',
                              texttableentry: 'FailureAdioModuleAnalogPortOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_80',
                              interval: '80',
                              texttableentry: 'FailureAdioModuleAnalogPortTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_81',
                              interval: '81',
                              texttableentry: 'FailureAdioModuleAnalogPortThree',
                            },
                            {
                              TI_texttableentry: 'TI_F_82',
                              interval: '82',
                              texttableentry: 'FailureCommunicationMixerModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_83',
                              interval: '83',
                              texttableentry: 'FailureMixerModuleDigitalOutput',
                            },
                            {
                              TI_texttableentry: 'TI_F_84',
                              interval: '84',
                              texttableentry: 'FailureMissingPowerSupplyPhase',
                            },
                            {
                              TI_texttableentry: 'TI_F_85',
                              interval: '85',
                              texttableentry: 'FailureWrongDirectionPowerSupplyPhaseAssignment',
                            },
                            {
                              TI_texttableentry: 'TI_F_86',
                              interval: '86',
                              texttableentry: 'FailureFlueGasRecirculationDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_87',
                              interval: '87',
                              texttableentry: 'OverloadSystemWaterPressure',
                            },
                            {
                              TI_texttableentry: 'TI_F_88',
                              interval: '88',
                              texttableentry: 'FailureSacrificialAnode',
                            },
                            {
                              TI_texttableentry: 'TI_F_89',
                              interval: '89',
                              texttableentry: 'FailureBlockingCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_90',
                              interval: '90',
                              texttableentry: 'FailureBlockingThreewayValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_91',
                              interval: '91',
                              texttableentry: 'FailureCommunicationDioModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_92',
                              interval: '92',
                              texttableentry: 'FailureCommunicationAdioModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_93',
                              interval: '93',
                              texttableentry: 'FailureCommunicationMTwoIoModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_94',
                              interval: '94',
                              texttableentry: 'FailureCommunicationSdioModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_95',
                              interval: '95',
                              texttableentry: 'FailureCommunicationOpenTherm',
                            },
                            {
                              TI_texttableentry: 'TI_F_96',
                              interval: '96',
                              texttableentry: 'FailureDioModuleDigitalPortOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_97',
                              interval: '97',
                              texttableentry: 'FailureDioModuleDigitalPortTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_98',
                              interval: '98',
                              texttableentry: 'FailureDioModuleDigitalPortThree',
                            },
                            {
                              TI_texttableentry: 'TI_F_99',
                              interval: '99',
                              texttableentry: 'FailurePlusBusCommunication',
                            },
                            {
                              TI_texttableentry: 'TI_F_100',
                              interval: '100',
                              texttableentry: 'FailurePlusBusVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_101',
                              interval: '101',
                              texttableentry: 'FailurePlusBusShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_102',
                              interval: '102',
                              texttableentry: 'FailureInternalCommunicationWiFiModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_103',
                              interval: '103',
                              texttableentry: 'FailureInternalCommunicationHmiModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_104',
                              interval: '104',
                              texttableentry: 'FailureExternalDevice',
                            },
                            {
                              TI_texttableentry: 'TI_F_105',
                              interval: '105',
                              texttableentry: 'FailureElectronicControlUnit',
                            },
                            {
                              TI_texttableentry: 'TI_F_106',
                              interval: '106',
                              texttableentry: 'FailureSuctionTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_107',
                              interval: '107',
                              texttableentry: 'FailureDischargeTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_108',
                              interval: '108',
                              texttableentry: 'FailureDischargePressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_109',
                              interval: '109',
                              texttableentry: 'FailureLiquidTemperatureOneSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_110',
                              interval: '110',
                              texttableentry: 'FailureLiquidTemperatureTwoSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_111',
                              interval: '111',
                              texttableentry:
                                'InterruptionPrimaryHeatExchangerLiquidTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_112',
                              interval: '112',
                              texttableentry:
                                'ShortCircuitPrimaryHeatExchangerLiquidTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_113',
                              interval: '113',
                              texttableentry: 'InterruptionCompressorInletPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_114',
                              interval: '114',
                              texttableentry: 'ShortCircuitCompressorInletPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_115',
                              interval: '115',
                              texttableentry: 'InterruptionIntermedPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_116',
                              interval: '116',
                              texttableentry: 'ShortCircuitIntermedPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_117',
                              interval: '117',
                              texttableentry: 'InterruptionEvaporatorVaporTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_118',
                              interval: '118',
                              texttableentry: 'ShortCircuitEvaporatorVaporTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_119',
                              interval: '119',
                              texttableentry: 'InterruptionLiquidLineTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_120',
                              interval: '120',
                              texttableentry: 'ShortCircuitLiquidLineTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_121',
                              interval: '121',
                              texttableentry: 'FailureCommunicationElectricalInverter',
                            },
                            {
                              TI_texttableentry: 'TI_F_122',
                              interval: '122',
                              texttableentry: 'FailureElectricalInverterIsUnsuitable',
                            },
                            {
                              TI_texttableentry: 'TI_F_123',
                              interval: '123',
                              texttableentry:
                                'InterruptionSecondaryHeatExchangerLiquidTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_124',
                              interval: '124',
                              texttableentry:
                                'ShortCircuitSecondaryHeatExchangerLiquidTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_125',
                              interval: '125',
                              texttableentry: 'InterruptionInverterAmbientTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_126',
                              interval: '126',
                              texttableentry: 'ShortCircuitInverterAmbientTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_127',
                              interval: '127',
                              texttableentry: 'FailureElectronicExpansionValveMotor',
                            },
                            {
                              TI_texttableentry: 'TI_F_128',
                              interval: '128',
                              texttableentry: 'OverHeatingDischargeSuperHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_129',
                              interval: '129',
                              texttableentry: 'InterruptionLiquidLevelSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_130',
                              interval: '130',
                              texttableentry: 'ShortCircuitLiquidLevelSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_131',
                              interval: '131',
                              texttableentry: 'FailureInrushCurrentLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_132',
                              interval: '132',
                              texttableentry: 'FailureInverterDriver',
                            },
                            {
                              TI_texttableentry: 'TI_F_133',
                              interval: '133',
                              texttableentry: 'FailureElectronicControlUnitInverter',
                            },
                            {
                              TI_texttableentry: 'TI_F_134',
                              interval: '134',
                              texttableentry: 'FailureCommunicationInverter',
                            },
                            {
                              TI_texttableentry: 'TI_F_135',
                              interval: '135',
                              texttableentry: 'FailurePhaseLoss',
                            },
                            {
                              TI_texttableentry: 'TI_F_136',
                              interval: '136',
                              texttableentry: 'InterruptionPhaseOneSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_137',
                              interval: '137',
                              texttableentry: 'ShortCircuitPhaseOneSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_138',
                              interval: '138',
                              texttableentry: 'InterruptionPhaseTwoSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_139',
                              interval: '139',
                              texttableentry: 'ShortCircuitPhaseTwoSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_140',
                              interval: '140',
                              texttableentry: 'InterruptionPhaseThreeSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_141',
                              interval: '141',
                              texttableentry: 'ShortCircuitPhasethreeSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_142',
                              interval: '142',
                              texttableentry: 'FailureCommunicationFanModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_143',
                              interval: '143',
                              texttableentry: 'OverheatingFanModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_144',
                              interval: '144',
                              texttableentry: 'FailureSpeedSensorFanModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_145',
                              interval: '145',
                              texttableentry: 'unused',
                            },
                            {
                              TI_texttableentry: 'TI_F_146',
                              interval: '146',
                              texttableentry: 'unusedTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_147',
                              interval: '147',
                              texttableentry: 'InterruptionCompressorInletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_148',
                              interval: '148',
                              texttableentry: 'ShortCircuitCompressorInletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_149',
                              interval: '149',
                              texttableentry: 'InterruptionEconomizerLiquidTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_150',
                              interval: '150',
                              texttableentry: 'ShortCircuitEconomizerLiquidTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_151',
                              interval: '151',
                              texttableentry: 'InterruptionCompressorOutletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_152',
                              interval: '152',
                              texttableentry: 'ShortCircuitCompressorOutletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_153',
                              interval: '153',
                              texttableentry: 'InterruptionCompressorOutletPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_154',
                              interval: '154',
                              texttableentry: 'ShortCircuitCompressorOutletPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_155',
                              interval: '155',
                              texttableentry: 'FailureElectronicExpansionValveOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_156',
                              interval: '156',
                              texttableentry: 'FailureElectronicExpansionValveTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_157',
                              interval: '157',
                              texttableentry: 'WatchdogHasTriggered',
                            },
                            {
                              TI_texttableentry: 'TI_F_158',
                              interval: '158',
                              texttableentry: 'AnalogDigitalConverterException',
                            },
                            {
                              TI_texttableentry: 'TI_F_159',
                              interval: '159',
                              texttableentry: 'DigitalAnalogConverterException',
                            },
                            {
                              TI_texttableentry: 'TI_F_160',
                              interval: '160',
                              texttableentry: 'CanCommunicationException',
                            },
                            {
                              TI_texttableentry: 'TI_F_161',
                              interval: '161',
                              texttableentry: 'RandomAccessMemoryException',
                            },
                            {
                              TI_texttableentry: 'TI_F_162',
                              interval: '162',
                              texttableentry: 'MicroControllerLowVoltageDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_163',
                              interval: '163',
                              texttableentry: 'CyclicRedundancyCheckException',
                            },
                            {
                              TI_texttableentry: 'TI_F_164',
                              interval: '164',
                              texttableentry: 'ErrorCodeCorrectionException',
                            },
                            {
                              TI_texttableentry: 'TI_F_165',
                              interval: '165',
                              texttableentry: 'GridBlackout',
                            },
                            {
                              TI_texttableentry: 'TI_F_166',
                              interval: '166',
                              texttableentry: 'GridVoltageUnstableOverShoot',
                            },
                            {
                              TI_texttableentry: 'TI_F_167',
                              interval: '167',
                              texttableentry: 'GridVoltageUnstableUnderShoot',
                            },
                            {
                              TI_texttableentry: 'TI_F_168',
                              interval: '168',
                              texttableentry: 'GridFrequencyUnstableOverShoot',
                            },
                            {
                              TI_texttableentry: 'TI_F_169',
                              interval: '169',
                              texttableentry: 'GridFrequencyUnstableUnderShoot',
                            },
                            {
                              TI_texttableentry: 'TI_F_170',
                              interval: '170',
                              texttableentry: 'GridOverVoltageEffectiveValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_171',
                              interval: '171',
                              texttableentry: 'GridUnderVoltageEffectiveValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_172',
                              interval: '172',
                              texttableentry: 'GridVoltageSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_173',
                              interval: '173',
                              texttableentry: 'GridCurrentSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_174',
                              interval: '174',
                              texttableentry: 'GridOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_175',
                              interval: '175',
                              texttableentry: 'DirectCurrentFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_176',
                              interval: '176',
                              texttableentry: 'DirectCurrentPowerSupplyFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_177',
                              interval: '177',
                              texttableentry: 'ParameterIdentificationNumberIsDifferent',
                            },
                            {
                              TI_texttableentry: 'TI_F_178',
                              interval: '178',
                              texttableentry: 'ParameterIdentificationNumberSynchroHasFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_179',
                              interval: '179',
                              texttableentry: 'ParameterIdentificationNumberIsNotEntered',
                            },
                            {
                              TI_texttableentry: 'TI_F_180',
                              interval: '180',
                              texttableentry: 'GasPressureLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_181',
                              interval: '181',
                              texttableentry: 'NoCentralHeatingFlowWater',
                            },
                            {
                              TI_texttableentry: 'TI_F_182',
                              interval: '182',
                              texttableentry: 'ShortCircuitDomesticHotWaterOutletSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_183',
                              interval: '183',
                              texttableentry: 'InterruptionDomesticHotWaterOutletSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_184',
                              interval: '184',
                              texttableentry: 'ShortCircuitSafetyTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_185',
                              interval: '185',
                              texttableentry: 'InterruptionSafetyTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_186',
                              interval: '186',
                              texttableentry: 'ErrorFuelValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_187',
                              interval: '187',
                              texttableentry: 'ErrorFuelValveDriver',
                            },
                            {
                              TI_texttableentry: 'TI_F_188',
                              interval: '188',
                              texttableentry: 'ErrorFuelValuePlausibilityCheck',
                            },
                            {
                              TI_texttableentry: 'TI_F_189',
                              interval: '189',
                              texttableentry: 'FuelCellBBFlameRodFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_190',
                              interval: '190',
                              texttableentry: 'FuelCellBBFlameRodFailureS',
                            },
                            {
                              TI_texttableentry: 'TI_F_191',
                              interval: '191',
                              texttableentry: 'FuelCellFlameRodFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_192',
                              interval: '192',
                              texttableentry: 'WaterNotFilled',
                            },
                            {
                              TI_texttableentry: 'TI_F_193',
                              interval: '193',
                              texttableentry: 'RunOutOfWaterFillingTime',
                            },
                            {
                              TI_texttableentry: 'TI_F_194',
                              interval: '194',
                              texttableentry: 'RunOutOfWaterRemovingProcedureTime',
                            },
                            {
                              TI_texttableentry: 'TI_F_195',
                              interval: '195',
                              texttableentry: 'CoDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_196',
                              interval: '196',
                              texttableentry: 'FlammableGasDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_197',
                              interval: '197',
                              texttableentry: 'FuelCellSoundnessCheckFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_198',
                              interval: '198',
                              texttableentry: 'IgnitionFailureOnStartUp',
                            },
                            {
                              TI_texttableentry: 'TI_F_199',
                              interval: '199',
                              texttableentry: 'IgnitionFailureAfterReignition',
                            },
                            {
                              TI_texttableentry: 'TI_F_200',
                              interval: '200',
                              texttableentry: 'HighCoConcentrationDetected',
                            },
                            {
                              TI_texttableentry: 'TI_F_201',
                              interval: '201',
                              texttableentry: 'FuelCellHighCoConcentrationDetectedS',
                            },
                            {
                              TI_texttableentry: 'TI_F_202',
                              interval: '202',
                              texttableentry: 'LowCoConcentrationDetected',
                            },
                            {
                              TI_texttableentry: 'TI_F_203',
                              interval: '203',
                              texttableentry: 'FuelCellLowCoConcentrationDetectedS',
                            },
                            {
                              TI_texttableentry: 'TI_F_204',
                              interval: '204',
                              texttableentry: 'FlameLostDuringHighCoConcentration',
                            },
                            {
                              TI_texttableentry: 'TI_F_205',
                              interval: '205',
                              texttableentry: 'FuelCellFlammableGasExhaustRisk',
                            },
                            {
                              TI_texttableentry: 'TI_F_206',
                              interval: '206',
                              texttableentry: 'FuelCellHighBackPressure',
                            },
                            {
                              TI_texttableentry: 'TI_F_207',
                              interval: '207',
                              texttableentry: 'RealtimeClockTemperatureAbnormityA',
                            },
                            {
                              TI_texttableentry: 'TI_F_208',
                              interval: '208',
                              texttableentry: 'RealtimeClockTemperatureAbnormityB',
                            },
                            {
                              TI_texttableentry: 'TI_F_209',
                              interval: '209',
                              texttableentry: 'RealtimeClockTemperatureAbnormityC',
                            },
                            {
                              TI_texttableentry: 'TI_F_210',
                              interval: '210',
                              texttableentry: 'StartUpFailureShiftCatalystThermocouple',
                            },
                            {
                              TI_texttableentry: 'TI_F_211',
                              interval: '211',
                              texttableentry:
                                'StartupFailurePreferentialOxidationTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_212',
                              interval: '212',
                              texttableentry: 'ReformingThermocoupleTemperatureHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_213',
                              interval: '213',
                              texttableentry: 'ReformingThermocoupleDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_214',
                              interval: '214',
                              texttableentry: 'ReformingThermocoupleShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_215',
                              interval: '215',
                              texttableentry: 'StartUpProcessWaterPumpTemperatureLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_216',
                              interval: '216',
                              texttableentry: 'StoppingProcessWaterPumpTemperatureHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_217',
                              interval: '217',
                              texttableentry: 'ShiftCatalystThermocoupleLowTemperatureInGenerating',
                            },
                            {
                              TI_texttableentry: 'TI_F_218',
                              interval: '218',
                              texttableentry: 'ShiftCatalystThermocoupleHighTemperatureInOperation',
                            },
                            {
                              TI_texttableentry: 'TI_F_219',
                              interval: '219',
                              texttableentry: 'ShiftCatalystThermocoupleDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_220',
                              interval: '220',
                              texttableentry: 'ShiftCatalystThermocoupleShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_221',
                              interval: '221',
                              texttableentry: 'ShiftCatalystThermocoupleLowTemperatureOnStartUp',
                            },
                            {
                              TI_texttableentry: 'TI_F_222',
                              interval: '222',
                              texttableentry: 'ShiftCatalystThermocoupleHighTemperatureInStopping',
                            },
                            {
                              TI_texttableentry: 'TI_F_223',
                              interval: '223',
                              texttableentry:
                                'PreferredOxidationTemperatureSensorLowTemperatureInGenerating',
                            },
                            {
                              TI_texttableentry: 'TI_F_224',
                              interval: '224',
                              texttableentry:
                                'PreferredOxidationTemperatureSensorHighTemperatureInOperating',
                            },
                            {
                              TI_texttableentry: 'TI_F_225',
                              interval: '225',
                              texttableentry: 'PreferredOxidationTemperatureSensorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_226',
                              interval: '226',
                              texttableentry: 'PreferredOxidationTemperatureSensorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_227',
                              interval: '227',
                              texttableentry:
                                'PreferredOxidationTemperatureSensorLowTemperatureOnStartUp',
                            },
                            {
                              TI_texttableentry: 'TI_F_228',
                              interval: '228',
                              texttableentry: 'DesulfurizingThermocoupleLowTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_229',
                              interval: '229',
                              texttableentry: 'DesulfurizingThermocoupleDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_230',
                              interval: '230',
                              texttableentry: 'DesulfurizingThermocoupleShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_231',
                              interval: '231',
                              texttableentry: 'DesulfurizingThermocoupleHighTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_232',
                              interval: '232',
                              texttableentry: 'DesulfurizingThermocoupleTemperatureErrorOnStartup',
                            },
                            {
                              TI_texttableentry: 'TI_F_233',
                              interval: '233',
                              texttableentry: 'FuelCellInletWaterThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_234',
                              interval: '234',
                              texttableentry: 'FuelCellInletWaterThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_235',
                              interval: '235',
                              texttableentry: 'FuelCellOutletWaterThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_236',
                              interval: '236',
                              texttableentry: 'FuelCellOutletWaterThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_237',
                              interval: '237',
                              texttableentry: 'FuelCellOutletWaterThermistorLowTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_238',
                              interval: '238',
                              texttableentry: 'FuelCellOutletWaterThermistorHighTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_239',
                              interval: '239',
                              texttableentry: 'CombustionAirFanBFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_240',
                              interval: '240',
                              texttableentry: 'CombustionAirFanBRotationSpeedFailureS',
                            },
                            {
                              TI_texttableentry: 'TI_F_241',
                              interval: '241',
                              texttableentry: 'CombustionAirFanBRotationSpeedFailureA',
                            },
                            {
                              TI_texttableentry: 'TI_F_242',
                              interval: '242',
                              texttableentry: 'FuelCellVentilationFanAFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_243',
                              interval: '243',
                              texttableentry: 'FuelCellGasValveAFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_244',
                              interval: '244',
                              texttableentry: 'FuelCellGasValveBFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_245',
                              interval: '245',
                              texttableentry: 'FuelCellFlammableGasDetector',
                            },
                            {
                              TI_texttableentry: 'TI_F_246',
                              interval: '246',
                              texttableentry: 'CoSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_247',
                              interval: '247',
                              texttableentry: 'CoSensorSignalShift',
                            },
                            {
                              TI_texttableentry: 'TI_F_248',
                              interval: '248',
                              texttableentry: 'FuelCellCoolingWaterCirculationPumpAirAccumulation',
                            },
                            {
                              TI_texttableentry: 'TI_F_249',
                              interval: '249',
                              texttableentry: 'FuelCellCoolingWaterCirculationPumpAtTestRun',
                            },
                            {
                              TI_texttableentry: 'TI_F_250',
                              interval: '250',
                              texttableentry: 'FuelCellFuelProcessorElectricalHeaterRelayFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_251',
                              interval: '251',
                              texttableentry: 'ExhaustGasPressureSensorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_252',
                              interval: '252',
                              texttableentry: 'ExhaustGasPressureSensorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_253',
                              interval: '253',
                              texttableentry: 'FuelCellVentilationFlapSticking',
                            },
                            {
                              TI_texttableentry: 'TI_F_254',
                              interval: '254',
                              texttableentry: 'SdCardFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_255',
                              interval: '255',
                              texttableentry: 'SdCardCommandError',
                            },
                            {
                              TI_texttableentry: 'TI_F_256',
                              interval: '256',
                              texttableentry: 'SdCardFormatError',
                            },
                            {
                              TI_texttableentry: 'TI_F_257',
                              interval: '257',
                              texttableentry: 'SdCardWriteProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_258',
                              interval: '258',
                              texttableentry: 'SdCardOutOfMemory',
                            },
                            {
                              TI_texttableentry: 'TI_F_259',
                              interval: '259',
                              texttableentry: 'SdCardUndetectable',
                            },
                            {
                              TI_texttableentry: 'TI_F_260',
                              interval: '260',
                              texttableentry: 'FuelCellPowerManagementSystemInverterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_261',
                              interval: '261',
                              texttableentry: 'FuelCellElectricCircuitPowerFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_262',
                              interval: '262',
                              texttableentry: 'FuelCellEepromAccessFailureABoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_263',
                              interval: '263',
                              texttableentry: 'FuelCellEepromAccessFailureVBoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_264',
                              interval: '264',
                              texttableentry: 'FuelCellEepromAccessFailureSBoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_265',
                              interval: '265',
                              texttableentry: 'FuelCellCommunicationErrorVBoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_266',
                              interval: '266',
                              texttableentry: 'FuelCellCommunicationErrorABoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_267',
                              interval: '267',
                              texttableentry: 'CommunicationErrorSdCard',
                            },
                            {
                              TI_texttableentry: 'TI_F_268',
                              interval: '268',
                              texttableentry: 'FuelCellCommunicationErrorSBoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_269',
                              interval: '269',
                              texttableentry: 'FuelCellCommunicationErrorViBoardPanasonicBoard',
                            },
                            {
                              TI_texttableentry: 'TI_F_270',
                              interval: '270',
                              texttableentry: 'FuelCellSBoardInternalPartsFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_271',
                              interval: '271',
                              texttableentry: 'FuelCellSBoardCircuitFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_272',
                              interval: '272',
                              texttableentry: 'FuelCellSBoardSoftwareFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_273',
                              interval: '273',
                              texttableentry: 'FuelCellOperationControlFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_274',
                              interval: '274',
                              texttableentry: 'FuelCellSystemInletThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_275',
                              interval: '275',
                              texttableentry: 'FuelCellSystemInletThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_276',
                              interval: '276',
                              texttableentry: 'FuelCellSystemOutletThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_277',
                              interval: '277',
                              texttableentry: 'FuelCellSystemOutletThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_278',
                              interval: '278',
                              texttableentry: 'FuelCellAntiFreezingThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_279',
                              interval: '279',
                              texttableentry: 'FuelCellAntiFreezingThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_280',
                              interval: '280',
                              texttableentry: 'FuelCellSystemInletTemperatureFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_281',
                              interval: '281',
                              texttableentry: 'FuelCellCondensDrainTankThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_282',
                              interval: '282',
                              texttableentry: 'FuelCellCondensDrainTankThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_283',
                              interval: '283',
                              texttableentry: 'FuelCellCoolingWaterTankThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_284',
                              interval: '284',
                              texttableentry: 'FuelCellCoolingWaterTankThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_285',
                              interval: '285',
                              texttableentry: 'FuelCellCoolingWaterTankThermistorHighTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_286',
                              interval: '286',
                              texttableentry: 'FuelCellAmbientThermistorDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_287',
                              interval: '287',
                              texttableentry: 'FuelCellAmbientThermistorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_288',
                              interval: '288',
                              texttableentry: 'FuelCellIntegratedGasPurgeVolumeFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_289',
                              interval: '289',
                              texttableentry: 'FuelCellIntegratedGasPurgeVolumeAtFlameOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_290',
                              interval: '290',
                              texttableentry: 'GasFlowMeterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_291',
                              interval: '291',
                              texttableentry: 'FuelCellGasFlowMeterLowFlowRateOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_292',
                              interval: '292',
                              texttableentry: 'FuelCellGasFlowMeterLowFlowRateTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_293',
                              interval: '293',
                              texttableentry: 'FuelCellDesulfurizerRunOutOfHydrogen',
                            },
                            {
                              TI_texttableentry: 'TI_F_294',
                              interval: '294',
                              texttableentry: 'ChimneyBlockage',
                            },
                            {
                              TI_texttableentry: 'TI_F_295',
                              interval: '295',
                              texttableentry: 'FuelCellPreferentialOxidationAirFlowMeterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_296',
                              interval: '296',
                              texttableentry: 'FuelCellGasUtilityFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_297',
                              interval: '297',
                              texttableentry: 'GasPressureSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_298',
                              interval: '298',
                              texttableentry: 'FuelCellIgniterCircuitFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_299',
                              interval: '299',
                              texttableentry: 'RealTimeClockFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_300',
                              interval: '300',
                              texttableentry:
                                'FuelCellPowerConditioningSystemOutputOverCurrentEffectiveValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_301',
                              interval: '301',
                              texttableentry:
                                'FuelCellPowerConditioningSystemOutputOverCurrentInstantValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_302',
                              interval: '302',
                              texttableentry:
                                'FuelCellPowerConditioningSystemOutputOverCurrentIpmFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_303',
                              interval: '303',
                              texttableentry: 'FuelCellPowerConditioningSystemInputVoltageDropOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_304',
                              interval: '304',
                              texttableentry: 'FuelCellPowerConditioningSystemInputVoltageDropTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_305',
                              interval: '305',
                              texttableentry:
                                'FuelCellPowerConditioningSystemInputVoltageDropThree',
                            },
                            {
                              TI_texttableentry: 'TI_F_306',
                              interval: '306',
                              texttableentry: 'FuelCellCurrentSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_307',
                              interval: '307',
                              texttableentry: 'PowerSupplyFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_308',
                              interval: '308',
                              texttableentry: 'LowPowerSupplyFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_309',
                              interval: '309',
                              texttableentry: 'LowPowerSupplyABoardFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_310',
                              interval: '310',
                              texttableentry: 'LowLowPowerSupplyFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_311',
                              interval: '311',
                              texttableentry: 'FuelCellPowerConditioningSystemInputOvervoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_312',
                              interval: '312',
                              texttableentry: 'DirectCurrentOvervoltageDetectedByHardware',
                            },
                            {
                              TI_texttableentry: 'TI_F_313',
                              interval: '313',
                              texttableentry: 'DirectCurrentOvervoltageDetectedBySoftware',
                            },
                            {
                              TI_texttableentry: 'TI_F_314',
                              interval: '314',
                              texttableentry: 'DirectCurrentVoltageDropDetectedBySoftware',
                            },
                            {
                              TI_texttableentry: 'TI_F_315',
                              interval: '315',
                              texttableentry: 'FuelCellPowerConditioningSystemFanFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_316',
                              interval: '316',
                              texttableentry: 'FuelCellPowerConditioningSystemInputOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_317',
                              interval: '317',
                              texttableentry:
                                'FuelCellPowerConditioningSystemInputCurrentSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_318',
                              interval: '318',
                              texttableentry: 'GridVoltageAnalogDigitalConverterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_319',
                              interval: '319',
                              texttableentry: 'RemoteControlCommandFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_320',
                              interval: '320',
                              texttableentry: 'FuelCellSurplusPowerHeaterDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_321',
                              interval: '321',
                              texttableentry: 'FuelCellSurplusPowerConverterCurrentSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_322',
                              interval: '322',
                              texttableentry: 'FuelCellSurplusPowerConverterVoltageSensorFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_323',
                              interval: '323',
                              texttableentry: 'AlternatingCurrentOvervoltageEffectiveValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_324',
                              interval: '324',
                              texttableentry: 'AlternatingCurrentOvervoltageAverageValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_325',
                              interval: '325',
                              texttableentry:
                                'AlternatingCurrentOvervoltageUandWPhaseEffectiveValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_326',
                              interval: '326',
                              texttableentry: 'AlternatingCurrentOvervoltageUandWPhaseInstantValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_327',
                              interval: '327',
                              texttableentry: 'IsolatingDetectionPassive',
                            },
                            {
                              TI_texttableentry: 'TI_F_328',
                              interval: '328',
                              texttableentry: 'IsolatingDetectionActive',
                            },
                            {
                              TI_texttableentry: 'TI_F_329',
                              interval: '329',
                              texttableentry: 'DirectCurrentPartDrain',
                            },
                            {
                              TI_texttableentry: 'TI_F_330',
                              interval: '330',
                              texttableentry: 'EmergencyEngineBlocked',
                            },
                            {
                              TI_texttableentry: 'TI_F_331',
                              interval: '331',
                              texttableentry: 'EmergencyEngineSecurityOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_332',
                              interval: '332',
                              texttableentry: 'EmergencyEngineSecurityOverCurrentWaitActive',
                            },
                            {
                              TI_texttableentry: 'TI_F_333',
                              interval: '333',
                              texttableentry: 'EnergySaveStateValveUnknown',
                            },
                            {
                              TI_texttableentry: 'TI_F_334',
                              interval: '334',
                              texttableentry: 'EnergySaveStateMassflowSensorUnknown',
                            },
                            {
                              TI_texttableentry: 'TI_F_335',
                              interval: '335',
                              texttableentry: 'EnergySaveStateStepperMotorUnknown',
                            },
                            {
                              TI_texttableentry: 'TI_F_336',
                              interval: '336',
                              texttableentry: 'ActualMassflowDeviationStateValueUnusable',
                            },
                            {
                              TI_texttableentry: 'TI_F_337',
                              interval: '337',
                              texttableentry: 'ActualMassflowDeviationStateValueWrong',
                            },
                            {
                              TI_texttableentry: 'TI_F_338',
                              interval: '338',
                              texttableentry: 'ActualAirTempDeviationStateNotOk',
                            },
                            {
                              TI_texttableentry: 'TI_F_339',
                              interval: '339',
                              texttableentry: 'ActualMotorSpeedDeviationStateUnusable',
                            },
                            {
                              TI_texttableentry: 'TI_F_340',
                              interval: '340',
                              texttableentry: 'ActualMassflowSlowDeviationStateValueUnusable',
                            },
                            {
                              TI_texttableentry: 'TI_F_341',
                              interval: '341',
                              texttableentry: 'FailureCommunicationFuelCell',
                            },
                            {
                              TI_texttableentry: 'TI_F_342',
                              interval: '342',
                              texttableentry: 'FailureCommunicationBurnerControlUnit',
                            },
                            {
                              TI_texttableentry: 'TI_F_343',
                              interval: '343',
                              texttableentry: 'ShortCircuitLowLossHeaderReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_344',
                              interval: '344',
                              texttableentry: 'InterruptionLowLossHeaderReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_345',
                              interval: '345',
                              texttableentry: 'OverHeatingProtectionTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_346',
                              interval: '346',
                              texttableentry: 'FailureIonisationCalibration',
                            },
                            {
                              TI_texttableentry: 'TI_F_347',
                              interval: '347',
                              texttableentry: 'AirGasRatioFeedbackDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_348',
                              interval: '348',
                              texttableentry: 'FailureGasValveAdaption',
                            },
                            {
                              TI_texttableentry: 'TI_F_349',
                              interval: '349',
                              texttableentry: 'FailureAirMassFlowAdaption',
                            },
                            {
                              TI_texttableentry: 'TI_F_350',
                              interval: '350',
                              texttableentry: 'FailureIonisationVoltageGenerationMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_351',
                              interval: '351',
                              texttableentry: 'FailureIonisationCurrentPlausibilityCheck',
                            },
                            {
                              TI_texttableentry: 'TI_F_352',
                              interval: '352',
                              texttableentry: 'FailureInternalAirGasRatioMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_353',
                              interval: '353',
                              texttableentry: 'FailureRetractFunctionMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_354',
                              interval: '354',
                              texttableentry: 'FailureGasValveFactoryOffset',
                            },
                            {
                              TI_texttableentry: 'TI_F_355',
                              interval: '355',
                              texttableentry: 'FailureSignalReferenceCheck',
                            },
                            {
                              TI_texttableentry: 'TI_F_356',
                              interval: '356',
                              texttableentry:
                                'NoFlameDuringStartingGasPressureInsufficientSafetyShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_357',
                              interval: '357',
                              texttableentry: 'NoFlameDuringStartingGasPressureInsufficientLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_358',
                              interval: '358',
                              texttableentry: 'NoFlameDuringStartingNoIgnitionSafetyShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_359',
                              interval: '359',
                              texttableentry: 'NoFlameDuringStartingNoIgnitionLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_360',
                              interval: '360',
                              texttableentry:
                                'NoFlameDuringStartingAgedIonizationElectrodeShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_361',
                              interval: '361',
                              texttableentry: 'NoFlameDuringStartingAgedIonizationElectrodeLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_362',
                              interval: '362',
                              texttableentry:
                                'NoFlameDuringStartingIonisationValueReferenceExaminationShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_363',
                              interval: '363',
                              texttableentry:
                                'NoFlameDuringStartingIonisationValueReferenceExaminationLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_364',
                              interval: '364',
                              texttableentry: 'FiniteStateMachineSystemErrorEntry',
                            },
                            {
                              TI_texttableentry: 'TI_F_365',
                              interval: '365',
                              texttableentry: 'FiniteStateMachineGasValveRelayTestFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_366',
                              interval: '366',
                              texttableentry:
                                'FiniteStateMachineGasValveWatchdogChannelOneTestFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_367',
                              interval: '367',
                              texttableentry:
                                'FiniteStateMachineGasValveWatchdogChannelTwoTestFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_368',
                              interval: '368',
                              texttableentry: 'FiniteStateMachineLowGasPressure',
                            },
                            {
                              TI_texttableentry: 'TI_F_369',
                              interval: '369',
                              texttableentry: 'FiniteStateMachineFlameLostDuringSafetyTime',
                            },
                            {
                              TI_texttableentry: 'TI_F_370',
                              interval: '370',
                              texttableentry:
                                'FiniteStateMachineGasValveRelayPlausibilityCheckFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_371',
                              interval: '371',
                              texttableentry: 'FiniteStateMachineLowerFanSpeedBoundFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_372',
                              interval: '372',
                              texttableentry: 'FiniteStateMachineFlameLostDuringIoCalibration',
                            },
                            {
                              TI_texttableentry: 'TI_F_373',
                              interval: '373',
                              texttableentry:
                                'FiniteStateMachineIoCalibrationOverheatingProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_374',
                              interval: '374',
                              texttableentry:
                                'FiniteStateMachineIoCalibrationPreProcessingStationaryStateFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_375',
                              interval: '375',
                              texttableentry:
                                'FiniteStateMachineIoCalibrationMinimumIncreaseAbortConditionFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_376',
                              interval: '376',
                              texttableentry:
                                'FiniteStateMachineIoCalibrationIonisationMaximumPlausibilityCheckFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_377',
                              interval: '377',
                              texttableentry:
                                'FiniteStateMachineIoCalibrationPostProcessingStationaryStateFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_378',
                              interval: '378',
                              texttableentry: 'FiniteStateMachineFlameLostDuringFlameStabilisation',
                            },
                            {
                              TI_texttableentry: 'TI_F_379',
                              interval: '379',
                              texttableentry: 'FiniteStateMachineNoFlameDuringStartLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_380',
                              interval: '380',
                              texttableentry: 'FiniteStateMachineFlameLostDuringStartLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_381',
                              interval: '381',
                              texttableentry: 'FiniteStateMachineFlameLostDuringOperationLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_382',
                              interval: '382',
                              texttableentry: 'FiniteStateMachineSystemErrorEntryLockOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_383',
                              interval: '383',
                              texttableentry: 'FiniteStateMachineMainGasValveShutOffFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_384',
                              interval: '384',
                              texttableentry: 'FiniteStateMachineModulationGasValveShutOffFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_385',
                              interval: '385',
                              texttableentry: 'ShortCircuitIonisationCurrentSignalOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_386',
                              interval: '386',
                              texttableentry: 'InterruptionIonisationCurrentSignalOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_387',
                              interval: '387',
                              texttableentry: 'ShortCircuitIonisationCurrentSignalTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_388',
                              interval: '388',
                              texttableentry: 'InterruptionIonisationCurrentSignalTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_389',
                              interval: '389',
                              texttableentry: 'ShortCircuitInternalPumpFeedbackSignal',
                            },
                            {
                              TI_texttableentry: 'TI_F_390',
                              interval: '390',
                              texttableentry: 'InterruptionInternalPumpFeedbackSignal',
                            },
                            {
                              TI_texttableentry: 'TI_F_391',
                              interval: '391',
                              texttableentry: 'ShortCircuitFlowTemperatureSensorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_392',
                              interval: '392',
                              texttableentry: 'InterruptionFlowTemperatureSensorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_393',
                              interval: '393',
                              texttableentry: 'ShortCircuitFlueGasTemperatureSensorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_394',
                              interval: '394',
                              texttableentry: 'InterruptionFlueGasTemperatureSensorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_395',
                              interval: '395',
                              texttableentry: 'ShortCircuitFlameTemperatureSignalOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_396',
                              interval: '396',
                              texttableentry: 'InterruptionFlameTemperatureSignalOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_397',
                              interval: '397',
                              texttableentry: 'ShortCircuitFlameTemperatureSignalTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_398',
                              interval: '398',
                              texttableentry: 'InterruptionFlameTemperatureSignalTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_399',
                              interval: '399',
                              texttableentry: 'ShortCircuitIonisationVoltageOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_400',
                              interval: '400',
                              texttableentry: 'InterruptionIonisationVoltageOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_401',
                              interval: '401',
                              texttableentry: 'ShortCircuitIonisationVoltageTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_402',
                              interval: '402',
                              texttableentry: 'InterruptionIonisationVoltageTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_403',
                              interval: '403',
                              texttableentry: 'ShortCircuitDynamicIonisationCurrentSignalOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_404',
                              interval: '404',
                              texttableentry: 'InterruptionDynamicIonisationCurrentSignalOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_405',
                              interval: '405',
                              texttableentry: 'ShortCircuitDynamicIonisationCurrentSignalTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_406',
                              interval: '406',
                              texttableentry: 'InterruptionDynamicIonisationCurrentSignalTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_407',
                              interval: '407',
                              texttableentry: 'SignalEvaluationSafetyChain',
                            },
                            {
                              TI_texttableentry: 'TI_F_408',
                              interval: '408',
                              texttableentry: 'SignalEvaluationGasValveRelayOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_409',
                              interval: '409',
                              texttableentry: 'SignalEvaluationGasValveRelayTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_410',
                              interval: '410',
                              texttableentry:
                                'FailureValidationMicroControllerSpecialFunctionRegister',
                            },
                            {
                              TI_texttableentry: 'TI_F_411',
                              interval: '411',
                              texttableentry: 'ShortCircuitInternalBoilerSensorOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_412',
                              interval: '412',
                              texttableentry: 'InterruptionInternalBoilerSensorOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_413',
                              interval: '413',
                              texttableentry: 'ShortCircuitInternalBoilerSensorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_414',
                              interval: '414',
                              texttableentry: 'InterruptionInternalBoilerSensorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_415',
                              interval: '415',
                              texttableentry: 'FailureCommunicationMBusGatewayOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_416',
                              interval: '416',
                              texttableentry: 'FlueGasTemperatureSensorNotInPosition',
                            },
                            {
                              TI_texttableentry: 'TI_F_417',
                              interval: '417',
                              texttableentry: 'ShortCircuitLowPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_418',
                              interval: '418',
                              texttableentry: 'InterruptionLowPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_419',
                              interval: '419',
                              texttableentry: 'ShortCircuitPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_420',
                              interval: '420',
                              texttableentry: 'InterruptionPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_421',
                              interval: '421',
                              texttableentry: 'FailurePersistentMemorySafetyRelevant',
                            },
                            {
                              TI_texttableentry: 'TI_F_422',
                              interval: '422',
                              texttableentry: 'FailurePersistentMemorySupplierParameter',
                            },
                            {
                              TI_texttableentry: 'TI_F_423',
                              interval: '423',
                              texttableentry: 'FailurePersistentMemoryCodingParameter',
                            },
                            {
                              TI_texttableentry: 'TI_F_424',
                              interval: '424',
                              texttableentry: 'FailurePersistentMemoryApplicationParameter',
                            },
                            {
                              TI_texttableentry: 'TI_F_425',
                              interval: '425',
                              texttableentry: 'FailureTimeSynchronizationFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_426',
                              interval: '426',
                              texttableentry: 'ExternalUnlockSignalRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_427',
                              interval: '427',
                              texttableentry: 'ExternalUnlockSignalRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_428',
                              interval: '428',
                              texttableentry: 'ExternalAirMassFlowSensorRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_429',
                              interval: '429',
                              texttableentry: 'ExternalAirMassFlowSensorRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_430',
                              interval: '430',
                              texttableentry: 'FailureCommunicationAutomationGateway',
                            },
                            {
                              TI_texttableentry: 'TI_F_431',
                              interval: '431',
                              texttableentry: 'FailureKnxCommunication',
                            },
                            {
                              TI_texttableentry: 'TI_F_432',
                              interval: '432',
                              texttableentry: 'ExternalFanSpeedSensorRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_433',
                              interval: '433',
                              texttableentry: 'ExternalFanSpeedSensorRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_434',
                              interval: '434',
                              texttableentry: 'ExternalPowerSupplyMonitoringRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_435',
                              interval: '435',
                              texttableentry: 'ExternalPowerSupplyMonitoringRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_436',
                              interval: '436',
                              texttableentry: 'ExternalAllengraWaterFlowSensorRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_437',
                              interval: '437',
                              texttableentry: 'ExternalAllengraWaterFlowSensorRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_438',
                              interval: '438',
                              texttableentry: 'ExternalAllengraTemperatureSensorRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_439',
                              interval: '439',
                              texttableentry: 'ExternalAllengraTemperatureSensorRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_440',
                              interval: '440',
                              texttableentry: 'ExternalGasPressureSwitchRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_441',
                              interval: '441',
                              texttableentry: 'ExternalGasPressureSwitchRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_442',
                              interval: '442',
                              texttableentry: 'ExternalFlueGasFlapRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_443',
                              interval: '443',
                              texttableentry: 'ExternalFlueGasFlapRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_444',
                              interval: '444',
                              texttableentry: 'ExternalSafetyGasValveRangeLowValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_445',
                              interval: '445',
                              texttableentry: 'ExternalSafetyGasValveRangeHighValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_446',
                              interval: '446',
                              texttableentry: 'SignalCompareSafetyTemperatureLimiterDeviation',
                            },
                            {
                              TI_texttableentry: 'TI_F_447',
                              interval: '447',
                              texttableentry: 'SignalCompareIonisationVoltageDeviation',
                            },
                            {
                              TI_texttableentry: 'TI_F_448',
                              interval: '448',
                              texttableentry: 'SignalCompareIonisationCurrentDeviation',
                            },
                            {
                              TI_texttableentry: 'TI_F_449',
                              interval: '449',
                              texttableentry: 'WatchdogTimerLowSignalTrigger',
                            },
                            {
                              TI_texttableentry: 'TI_F_450',
                              interval: '450',
                              texttableentry: 'WatchdogTimerHighSignalTrigger',
                            },
                            {
                              TI_texttableentry: 'TI_F_451',
                              interval: '451',
                              texttableentry: 'FailureMainProgramRotationSynchronisation',
                            },
                            {
                              TI_texttableentry: 'TI_F_452',
                              interval: '452',
                              texttableentry: 'FailureControllerSynchronisation',
                            },
                            {
                              TI_texttableentry: 'TI_F_453',
                              interval: '453',
                              texttableentry: 'FailureFiniteStateMachineNextStepComparison',
                            },
                            {
                              TI_texttableentry: 'TI_F_454',
                              interval: '454',
                              texttableentry: 'FailureSoftwareConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_455',
                              interval: '455',
                              texttableentry: 'FailureLogicalProgramFlowMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_456',
                              interval: '456',
                              texttableentry: 'FailureStartupControllerSynchronisationToken',
                            },
                            {
                              TI_texttableentry: 'TI_F_457',
                              interval: '457',
                              texttableentry: 'FailureFanModuleEmergencyMessage',
                            },
                            {
                              TI_texttableentry: 'TI_F_458',
                              interval: '458',
                              texttableentry: 'FailureUnlockSignalPlausibilityCheck',
                            },
                            {
                              TI_texttableentry: 'TI_F_459',
                              interval: '459',
                              texttableentry: 'FiniteStateMachineCalibrationErrorSafetyShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_460',
                              interval: '460',
                              texttableentry: 'FiniteStateMachineGeneralErrorSafetyShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_461',
                              interval: '461',
                              texttableentry: 'FiniteStateMachineFlueGasFlapFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_462',
                              interval: '462',
                              texttableentry: 'FiniteStateMachineSafetyGasValveFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_463',
                              interval: '463',
                              texttableentry:
                                'FailureCalibrationMaximumIonisationLowerFactoryBound',
                            },
                            {
                              TI_texttableentry: 'TI_F_464',
                              interval: '464',
                              texttableentry:
                                'FailureCalibrationMaximumIonisationPredecessorValueBound',
                            },
                            {
                              TI_texttableentry: 'TI_F_465',
                              interval: '465',
                              texttableentry:
                                'FailureCalibrationMaximumIonisationStationaryStateNotReached',
                            },
                            {
                              TI_texttableentry: 'TI_F_466',
                              interval: '466',
                              texttableentry: 'FailureCalibrationMaximumIonisationNotPossible',
                            },
                            {
                              TI_texttableentry: 'TI_F_467',
                              interval: '467',
                              texttableentry:
                                'FailureCalibrationMaximumIonisationAbortConditionNotReached',
                            },
                            {
                              TI_texttableentry: 'TI_F_468',
                              interval: '468',
                              texttableentry:
                                'FailureCalibrationMaximumIonisationUpperFactoryBound',
                            },
                            {
                              TI_texttableentry: 'TI_F_469',
                              interval: '469',
                              texttableentry: 'FailureCalibrationMaximumIonisationOverheat',
                            },
                            {
                              TI_texttableentry: 'TI_F_470',
                              interval: '470',
                              texttableentry: 'UpdateError',
                            },
                            {
                              TI_texttableentry: 'TI_F_471',
                              interval: '471',
                              texttableentry: 'WaterPressureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_472',
                              interval: '472',
                              texttableentry: 'FailureCommunicationEnergyMeter',
                            },
                            {
                              TI_texttableentry: 'TI_F_473',
                              interval: '473',
                              texttableentry: 'FailureCommunicationHMU',
                            },
                            {
                              TI_texttableentry: 'TI_F_474',
                              interval: '474',
                              texttableentry: 'FailureTimingProgramFlowMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_475',
                              interval: '475',
                              texttableentry: 'AirInFuelCellSeparationCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_476',
                              interval: '476',
                              texttableentry: 'FuelCellAmbientTemperatureTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_477',
                              interval: '477',
                              texttableentry: 'FailureSolarDeltaTemperatureMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_478',
                              interval: '478',
                              texttableentry: 'FailureNightCirculationMonitoring',
                            },
                            {
                              TI_texttableentry: 'TI_F_479',
                              interval: '479',
                              texttableentry: 'ShortCircuitStepperMotorOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_480',
                              interval: '480',
                              texttableentry: 'ShortCircuitStepperMotorTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_481',
                              interval: '481',
                              texttableentry: 'MixerFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_482',
                              interval: '482',
                              texttableentry: 'MixerOneFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_483',
                              interval: '483',
                              texttableentry: 'MixerTwoFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_484',
                              interval: '484',
                              texttableentry: 'MixerThreeFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_485',
                              interval: '485',
                              texttableentry: 'MixerFourFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_486',
                              interval: '486',
                              texttableentry: 'MixerFiveFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_487',
                              interval: '487',
                              texttableentry: 'MixerSixFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_488',
                              interval: '488',
                              texttableentry: 'MixerSevenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_489',
                              interval: '489',
                              texttableentry: 'MixerEightFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_490',
                              interval: '490',
                              texttableentry: 'MixerNineFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_491',
                              interval: '491',
                              texttableentry: 'MixerTenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_492',
                              interval: '492',
                              texttableentry: 'MixerElevenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_493',
                              interval: '493',
                              texttableentry: 'MixerTwelveFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_494',
                              interval: '494',
                              texttableentry: 'MixerThirteenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_495',
                              interval: '495',
                              texttableentry: 'MixerFifteenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_496',
                              interval: '496',
                              texttableentry: 'MixerSixteenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_497',
                              interval: '497',
                              texttableentry: 'MixerReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_498',
                              interval: '498',
                              texttableentry: 'MixerOneReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_499',
                              interval: '499',
                              texttableentry: 'MixerTwoReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_500',
                              interval: '500',
                              texttableentry: 'MixerThreeReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_501',
                              interval: '501',
                              texttableentry: 'MixerFourReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_502',
                              interval: '502',
                              texttableentry: 'MixerFiveReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_503',
                              interval: '503',
                              texttableentry: 'MixerSixReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_504',
                              interval: '504',
                              texttableentry: 'MixerSevenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_505',
                              interval: '505',
                              texttableentry: 'MixerEightReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_506',
                              interval: '506',
                              texttableentry: 'MixerNineReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_507',
                              interval: '507',
                              texttableentry: 'MixerTenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_508',
                              interval: '508',
                              texttableentry: 'MixerElevenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_509',
                              interval: '509',
                              texttableentry: 'MixerTwelveReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_510',
                              interval: '510',
                              texttableentry: 'MixerThirteenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_511',
                              interval: '511',
                              texttableentry: 'MixerFifteenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_512',
                              interval: '512',
                              texttableentry: 'MixerSixteenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_513',
                              interval: '513',
                              texttableentry: 'HydraulicSeparatorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_514',
                              interval: '514',
                              texttableentry: 'SolarFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_515',
                              interval: '515',
                              texttableentry: 'SolarReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_516',
                              interval: '516',
                              texttableentry: 'SolarRoofSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_517',
                              interval: '517',
                              texttableentry: 'FailureCommunicationWiredRemoteControl',
                            },
                            {
                              TI_texttableentry: 'TI_F_518',
                              interval: '518',
                              texttableentry: 'FailureCommunicationWirelessRemoteControl',
                            },
                            {
                              TI_texttableentry: 'TI_F_519',
                              interval: '519',
                              texttableentry: 'FailureBacNetCommunication',
                            },
                            {
                              TI_texttableentry: 'TI_F_520',
                              interval: '520',
                              texttableentry: 'FailureModbusCommunication',
                            },
                            {
                              TI_texttableentry: 'TI_F_521',
                              interval: '521',
                              texttableentry: 'MixerFourteenFlowTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_522',
                              interval: '522',
                              texttableentry: 'MixerFourteenReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_523',
                              interval: '523',
                              texttableentry: 'NoFlameDuringStartingBeforeSupplyingReformingWater',
                            },
                            {
                              TI_texttableentry: 'TI_F_524',
                              interval: '524',
                              texttableentry: 'NoFlameDuringStartingAfterSupplyingReformingWater',
                            },
                            {
                              TI_texttableentry: 'TI_F_525',
                              interval: '525',
                              texttableentry: 'FailureCoDetectionUnit',
                            },
                            {
                              TI_texttableentry: 'TI_F_526',
                              interval: '526',
                              texttableentry: 'CoSensorSignalShiftA',
                            },
                            {
                              TI_texttableentry: 'TI_F_527',
                              interval: '527',
                              texttableentry: 'ParameterizationIncomplete',
                            },
                            {
                              TI_texttableentry: 'TI_F_528',
                              interval: '528',
                              texttableentry: 'BaseProgrammingIncomplete',
                            },
                            {
                              TI_texttableentry: 'TI_F_529',
                              interval: '529',
                              texttableentry: 'ProcessWaterValveOpenLocked',
                            },
                            {
                              TI_texttableentry: 'TI_F_530',
                              interval: '530',
                              texttableentry: 'SolarFunctionRestrictedDueToMissingSensorValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_531',
                              interval: '531',
                              texttableentry: 'EnergyStorageCellDrift',
                            },
                            {
                              TI_texttableentry: 'TI_F_532',
                              interval: '532',
                              texttableentry: 'EnergyStorageCellOverVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_533',
                              interval: '533',
                              texttableentry: 'EnergyStorageCellUnderVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_534',
                              interval: '534',
                              texttableentry: 'FailureCommunicationEnergyStorage',
                            },
                            {
                              TI_texttableentry: 'TI_F_535',
                              interval: '535',
                              texttableentry: 'FailureCommunicationEnergyStorageCell',
                            },
                            {
                              TI_texttableentry: 'TI_F_536',
                              interval: '536',
                              texttableentry: 'InterruptionSystemFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_537',
                              interval: '537',
                              texttableentry: 'ShortCircuitSystemFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_538',
                              interval: '538',
                              texttableentry: 'InterruptionSystemReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_539',
                              interval: '539',
                              texttableentry: 'ShortCircuitSystemReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_540',
                              interval: '540',
                              texttableentry: 'HeatCellCondensatDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_541',
                              interval: '541',
                              texttableentry: 'FailureExhaustFlapFeedback',
                            },
                            {
                              TI_texttableentry: 'TI_F_542',
                              interval: '542',
                              texttableentry: 'InterruptionMixerOneFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_543',
                              interval: '543',
                              texttableentry: 'ShortCircuitMixerOneFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_544',
                              interval: '544',
                              texttableentry: 'InterruptionMixerTwoFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_545',
                              interval: '545',
                              texttableentry: 'ShortCircuitMixerTwoFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_546',
                              interval: '546',
                              texttableentry: 'InterruptionMixerThreeFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_547',
                              interval: '547',
                              texttableentry: 'ShortCircuitMixerThreeFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_548',
                              interval: '548',
                              texttableentry: 'InterruptionMixerFourFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_549',
                              interval: '549',
                              texttableentry: 'ShortCircuitMixerFourFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_550',
                              interval: '550',
                              texttableentry: 'InterruptionMixerFiveFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_551',
                              interval: '551',
                              texttableentry: 'ShortCircuitMixerFiveFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_552',
                              interval: '552',
                              texttableentry: 'InterruptionMixerSixFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_553',
                              interval: '553',
                              texttableentry: 'ShortCircuitMixerSixFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_554',
                              interval: '554',
                              texttableentry: 'InterruptionMixerSevenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_555',
                              interval: '555',
                              texttableentry: 'ShortCircuitMixerSevenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_556',
                              interval: '556',
                              texttableentry: 'InterruptionMixerEightFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_557',
                              interval: '557',
                              texttableentry: 'ShortCircuitMixerEightFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_558',
                              interval: '558',
                              texttableentry: 'InterruptionMixerNineFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_559',
                              interval: '559',
                              texttableentry: 'ShortCircuitMixerNineFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_560',
                              interval: '560',
                              texttableentry: 'InterruptionMixerTenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_561',
                              interval: '561',
                              texttableentry: 'ShortCircuitMixerTenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_562',
                              interval: '562',
                              texttableentry: 'InterruptionMixerElevenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_563',
                              interval: '563',
                              texttableentry: 'ShortCircuitMixerElevenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_564',
                              interval: '564',
                              texttableentry: 'InterruptionMixerTwelveFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_565',
                              interval: '565',
                              texttableentry: 'ShortCircuitMixerTwelveFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_566',
                              interval: '566',
                              texttableentry: 'InterruptionMixerThirteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_567',
                              interval: '567',
                              texttableentry: 'ShortCircuitMixerThirteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_568',
                              interval: '568',
                              texttableentry: 'InterruptionMixerFourteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_569',
                              interval: '569',
                              texttableentry: 'ShortCircuitMixerFourteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_570',
                              interval: '570',
                              texttableentry: 'InterruptionMixerFifteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_571',
                              interval: '571',
                              texttableentry: 'ShortCircuitMixerFifteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_572',
                              interval: '572',
                              texttableentry: 'InterruptionMixerSixteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_573',
                              interval: '573',
                              texttableentry: 'ShortCircuitMixerSixteenFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_574',
                              interval: '574',
                              texttableentry: 'MixerOneRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_575',
                              interval: '575',
                              texttableentry: 'InterruptionMixerOneRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_576',
                              interval: '576',
                              texttableentry: 'ShortCircuitMixerOneRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_577',
                              interval: '577',
                              texttableentry: 'MixerTwoRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_578',
                              interval: '578',
                              texttableentry: 'InterruptionMixerTwoRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_579',
                              interval: '579',
                              texttableentry: 'ShortCircuitMixerTwoRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_580',
                              interval: '580',
                              texttableentry: 'MixerThreeRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_581',
                              interval: '581',
                              texttableentry: 'InterruptionMixerThreeRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_582',
                              interval: '582',
                              texttableentry: 'ShortCircuitMixerThreeRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_583',
                              interval: '583',
                              texttableentry: 'MixerFourRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_584',
                              interval: '584',
                              texttableentry: 'InterruptionMixerFourRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_585',
                              interval: '585',
                              texttableentry: 'ShortCircuitMixerFourRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_586',
                              interval: '586',
                              texttableentry: 'MixerFiveRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_587',
                              interval: '587',
                              texttableentry: 'InterruptionMixerFiveRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_588',
                              interval: '588',
                              texttableentry: 'ShortCircuitMixerFiveRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_589',
                              interval: '589',
                              texttableentry: 'MixerSixRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_590',
                              interval: '590',
                              texttableentry: 'InterruptionMixerSixRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_591',
                              interval: '591',
                              texttableentry: 'ShortCircuitMixerSixRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_592',
                              interval: '592',
                              texttableentry: 'MixerSevenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_593',
                              interval: '593',
                              texttableentry: 'InterruptionMixerSevenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_594',
                              interval: '594',
                              texttableentry: 'ShortCircuitMixerSevenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_595',
                              interval: '595',
                              texttableentry: 'MixerEightRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_596',
                              interval: '596',
                              texttableentry: 'InterruptionMixerEightRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_597',
                              interval: '597',
                              texttableentry: 'ShortCircuitMixerEightRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_598',
                              interval: '598',
                              texttableentry: 'MixerNineRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_599',
                              interval: '599',
                              texttableentry: 'InterruptionMixerNineRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_600',
                              interval: '600',
                              texttableentry: 'ShortCircuitMixerNineRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_601',
                              interval: '601',
                              texttableentry: 'MixerTenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_602',
                              interval: '602',
                              texttableentry: 'InterruptionMixerTenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_603',
                              interval: '603',
                              texttableentry: 'ShortCircuitMixerTenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_604',
                              interval: '604',
                              texttableentry: 'MixerElevenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_605',
                              interval: '605',
                              texttableentry: 'InterruptionMixerElevenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_606',
                              interval: '606',
                              texttableentry: 'ShortCircuitMixerElevenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_607',
                              interval: '607',
                              texttableentry: 'MixerTwelveRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_608',
                              interval: '608',
                              texttableentry: 'InterruptionMixerTwelveRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_609',
                              interval: '609',
                              texttableentry: 'ShortCircuitMixerTwelveRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_610',
                              interval: '610',
                              texttableentry: 'MixerThirteenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_611',
                              interval: '611',
                              texttableentry: 'InterruptionMixerThirteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_612',
                              interval: '612',
                              texttableentry: 'ShortCircuitMixerThirteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_613',
                              interval: '613',
                              texttableentry: 'MixerFourteenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_614',
                              interval: '614',
                              texttableentry: 'InterruptionMixerFourteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_615',
                              interval: '615',
                              texttableentry: 'ShortCircuitMixerFourteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_616',
                              interval: '616',
                              texttableentry: 'SoftwareVersionCheckFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_617',
                              interval: '617',
                              texttableentry: 'MixerFifteenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_618',
                              interval: '618',
                              texttableentry: 'InterruptionMixerFifteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_619',
                              interval: '619',
                              texttableentry: 'ShortCircuitMixerFifteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_620',
                              interval: '620',
                              texttableentry: 'MixerSixteenRoomTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_621',
                              interval: '621',
                              texttableentry: 'InterruptionMixerSixteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_622',
                              interval: '622',
                              texttableentry: 'ShortCircuitMixerSixteenRoomTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_623',
                              interval: '623',
                              texttableentry: 'InterruptionMixerOneReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_624',
                              interval: '624',
                              texttableentry: 'ShortCircuitMixerOneReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_625',
                              interval: '625',
                              texttableentry: 'InterruptionMixerTwoReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_626',
                              interval: '626',
                              texttableentry: 'ShortCircuitMixerTwoReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_627',
                              interval: '627',
                              texttableentry: 'InterruptionMixerThreeReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_628',
                              interval: '628',
                              texttableentry: 'ShortCircuitMixerThreeReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_629',
                              interval: '629',
                              texttableentry: 'InterruptionMixerFourReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_630',
                              interval: '630',
                              texttableentry: 'ShortCircuitMixerFourReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_631',
                              interval: '631',
                              texttableentry: 'InterruptionMixerFiveReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_632',
                              interval: '632',
                              texttableentry: 'ShortCircuitMixerFiveReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_633',
                              interval: '633',
                              texttableentry: 'InterruptionMixerSixReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_634',
                              interval: '634',
                              texttableentry: 'ShortCircuitMixerSixReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_635',
                              interval: '635',
                              texttableentry: 'InterruptionMixerSevenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_636',
                              interval: '636',
                              texttableentry: 'ShortCircuitMixerSevenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_637',
                              interval: '637',
                              texttableentry: 'InterruptionMixerEightReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_638',
                              interval: '638',
                              texttableentry: 'ShortCircuitMixerEightReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_639',
                              interval: '639',
                              texttableentry: 'InterruptionMixerNineReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_640',
                              interval: '640',
                              texttableentry: 'ShortCircuitMixerNineReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_641',
                              interval: '641',
                              texttableentry: 'InterruptionMixerTenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_642',
                              interval: '642',
                              texttableentry: 'ShortCircuitMixerTenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_643',
                              interval: '643',
                              texttableentry: 'InterruptionMixerElevenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_644',
                              interval: '644',
                              texttableentry: 'ShortCircuitMixerElevenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_645',
                              interval: '645',
                              texttableentry: 'InterruptionMixerTwelveReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_646',
                              interval: '646',
                              texttableentry: 'ShortCircuitMixerTwelveReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_647',
                              interval: '647',
                              texttableentry: 'InterruptionMixerThirteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_648',
                              interval: '648',
                              texttableentry: 'ShortCircuitMixerThirteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_649',
                              interval: '649',
                              texttableentry: 'InterruptionMixerFourteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_650',
                              interval: '650',
                              texttableentry: 'ShortCircuitMixerFourteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_651',
                              interval: '651',
                              texttableentry: 'InterruptionMixerFifteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_652',
                              interval: '652',
                              texttableentry: 'ShortCircuitMixerFifteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_653',
                              interval: '653',
                              texttableentry: 'InterruptionMixerSixteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_654',
                              interval: '654',
                              texttableentry: 'ShortCircuitMixerSixteenReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_655',
                              interval: '655',
                              texttableentry: 'InterruptionIncreasedReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_656',
                              interval: '656',
                              texttableentry: 'ShortCircuitIncreasedReturnTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_657',
                              interval: '657',
                              texttableentry: 'PreChargePeriodExceedsMaximumTime',
                            },
                            {
                              TI_texttableentry: 'TI_F_658',
                              interval: '658',
                              texttableentry: 'CurrentMeassuringCircuitFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_659',
                              interval: '659',
                              texttableentry: 'MainPowerPathVoltageFeedback',
                            },
                            {
                              TI_texttableentry: 'TI_F_660',
                              interval: '660',
                              texttableentry: 'PreChargeCircuitVoltageFeedback',
                            },
                            {
                              TI_texttableentry: 'TI_F_661',
                              interval: '661',
                              texttableentry: 'SignalCompareCurrentDeviation',
                            },
                            {
                              TI_texttableentry: 'TI_F_662',
                              interval: '662',
                              texttableentry: 'ChargingOvercurrentFailureFirstProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_663',
                              interval: '663',
                              texttableentry: 'ChargingOvercurrentFailureSecondProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_664',
                              interval: '664',
                              texttableentry: 'DischargingOvercurrentFailureFirstProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_665',
                              interval: '665',
                              texttableentry: 'DischargingOvercurrentFailureSecondProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_666',
                              interval: '666',
                              texttableentry:
                                'InterruptionDifferentialTemperatureControllerHeatSourceTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_667',
                              interval: '667',
                              texttableentry:
                                'ShortCircuitDifferentialTemperatureControllerHeatSourceTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_668',
                              interval: '668',
                              texttableentry:
                                'InterruptionDifferentialTemperatureControllerHeatSinkTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_669',
                              interval: '669',
                              texttableentry:
                                'ShortCircuitDifferentialTemperatureControllerHeatSinkTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_670',
                              interval: '670',
                              texttableentry: 'InterruptionHeatingSupportBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_671',
                              interval: '671',
                              texttableentry: 'ShortCircuitHeatingSupportBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_672',
                              interval: '672',
                              texttableentry: 'InterruptionPreheatingReferenceTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_673',
                              interval: '673',
                              texttableentry: 'ShortCircuitPreheatingReferenceTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_674',
                              interval: '674',
                              texttableentry: 'UnderTemperatureFailureFirstProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_675',
                              interval: '675',
                              texttableentry: 'OverTemperatureFailureFirstProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_676',
                              interval: '676',
                              texttableentry: 'UnderTemperatureFailureSecondProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_677',
                              interval: '677',
                              texttableentry: 'OverTemperatureFailureSecondProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_678',
                              interval: '678',
                              texttableentry: 'UnderVoltageFailureFirstProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_679',
                              interval: '679',
                              texttableentry: 'OverVoltageFailureFirstProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_680',
                              interval: '680',
                              texttableentry: 'UnderVoltageFailureSecondProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_681',
                              interval: '681',
                              texttableentry: 'OverVoltageFailureSecondProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_682',
                              interval: '682',
                              texttableentry: 'AirMassFlowSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_683',
                              interval: '683',
                              texttableentry: 'AirMassFlowSensorDefective',
                            },
                            {
                              TI_texttableentry: 'TI_F_684',
                              interval: '684',
                              texttableentry: 'AirBackflowFlapDefective',
                            },
                            {
                              TI_texttableentry: 'TI_F_685',
                              interval: '685',
                              texttableentry: 'FailureCommunicationHPMU',
                            },
                            {
                              TI_texttableentry: 'TI_F_686',
                              interval: '686',
                              texttableentry: 'FailureCommunicationRefrigerantController',
                            },
                            {
                              TI_texttableentry: 'TI_F_687',
                              interval: '687',
                              texttableentry: 'FailureCommunicationEHCU',
                            },
                            {
                              TI_texttableentry: 'TI_F_688',
                              interval: '688',
                              texttableentry: 'FailureCommunicationMZIOModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_689',
                              interval: '689',
                              texttableentry: 'ElectricalEnergyStorageCellVoltageStatusError',
                            },
                            {
                              TI_texttableentry: 'TI_F_690',
                              interval: '690',
                              texttableentry: 'ElectricalEnergyStorageCellTemperatureStatusError',
                            },
                            {
                              TI_texttableentry: 'TI_F_691',
                              interval: '691',
                              texttableentry: 'CombustionAirInterlockMissingFeedback',
                            },
                            {
                              TI_texttableentry: 'TI_F_692',
                              interval: '692',
                              texttableentry: 'CombustionAirInterlockClosedDuringActivation',
                            },
                            {
                              TI_texttableentry: 'TI_F_693',
                              interval: '693',
                              texttableentry: 'InterruptionFlueGasSafetyTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_694',
                              interval: '694',
                              texttableentry: 'DeviationFlueGasSafetyTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_695',
                              interval: '695',
                              texttableentry: 'PyrofuseDetonated',
                            },
                            {
                              TI_texttableentry: 'TI_F_696',
                              interval: '696',
                              texttableentry: 'ShortCircuitFlueGasSafetyTemperatureLimiter',
                            },
                            {
                              TI_texttableentry: 'TI_F_697',
                              interval: '697',
                              texttableentry: 'MainRelayLifeCycleExpired',
                            },
                            {
                              TI_texttableentry: 'TI_F_698',
                              interval: '698',
                              texttableentry: 'ElectricalEnergyStorageStateInconsistency',
                            },
                            {
                              TI_texttableentry: 'TI_F_699',
                              interval: '699',
                              texttableentry: 'ElectricalEnergyStoragePrechargeTimeout',
                            },
                            {
                              TI_texttableentry: 'TI_F_700',
                              interval: '700',
                              texttableentry: 'ElectricalEnergyStorageOvervoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_701',
                              interval: '701',
                              texttableentry: 'ElectricalEnergyStorageUndervoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_702',
                              interval: '702',
                              texttableentry: 'ElectricalEnergyStorageOvercurrentCharge',
                            },
                            {
                              TI_texttableentry: 'TI_F_703',
                              interval: '703',
                              texttableentry: 'ElectricalEnergyStorageOvercurrentDischarge',
                            },
                            {
                              TI_texttableentry: 'TI_F_704',
                              interval: '704',
                              texttableentry: 'ElectricalEnergyStorageOvertemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_705',
                              interval: '705',
                              texttableentry: 'ElectricalEnergyStorageUndertemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_706',
                              interval: '706',
                              texttableentry: 'GridVoltageTooLowForReconnect',
                            },
                            {
                              TI_texttableentry: 'TI_F_707',
                              interval: '707',
                              texttableentry: 'GridVoltageTooHighForReconnect',
                            },
                            {
                              TI_texttableentry: 'TI_F_708',
                              interval: '708',
                              texttableentry: 'GridVoltageAverageTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_709',
                              interval: '709',
                              texttableentry: 'GridVoltageAverageTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_710',
                              interval: '710',
                              texttableentry: 'GridFrequencyTooLowForReconnect',
                            },
                            {
                              TI_texttableentry: 'TI_F_711',
                              interval: '711',
                              texttableentry: 'GridFrequencyTooHighForReconnect',
                            },
                            {
                              TI_texttableentry: 'TI_F_712',
                              interval: '712',
                              texttableentry: 'ResidualCurrentTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_713',
                              interval: '713',
                              texttableentry: 'ElectricalIsolationFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_714',
                              interval: '714',
                              texttableentry: 'CSCConfigurationChanged',
                            },
                            {
                              TI_texttableentry: 'TI_F_715',
                              interval: '715',
                              texttableentry: 'GridRelaisDefect',
                            },
                            {
                              TI_texttableentry: 'TI_F_716',
                              interval: '716',
                              texttableentry: 'Phasereversed',
                            },
                            {
                              TI_texttableentry: 'TI_F_717',
                              interval: '717',
                              texttableentry: 'GridVoltagePhaseOneTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_718',
                              interval: '718',
                              texttableentry: 'GridVoltagePhaseTwoTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_719',
                              interval: '719',
                              texttableentry: 'FailureCommunicationEnergyManager',
                            },
                            {
                              TI_texttableentry: 'TI_F_720',
                              interval: '720',
                              texttableentry: 'FailureCommunicationDemandResponseModeControl',
                            },
                            {
                              TI_texttableentry: 'TI_F_721',
                              interval: '721',
                              texttableentry: 'TestExternalWatchdogFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_722',
                              interval: '722',
                              texttableentry: 'EmergencyCircuitShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_723',
                              interval: '723',
                              texttableentry: 'CSCCountNotPlausible',
                            },
                            {
                              TI_texttableentry: 'TI_F_724',
                              interval: '724',
                              texttableentry: 'CSCTypeNotPlausible',
                            },
                            {
                              TI_texttableentry: 'TI_F_725',
                              interval: '725',
                              texttableentry: 'AmbientTemperatureSensorInterruption',
                            },
                            {
                              TI_texttableentry: 'TI_F_726',
                              interval: '726',
                              texttableentry: 'AmbientTemperatureSensorShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_727',
                              interval: '727',
                              texttableentry: 'CSCBatteryVoltageNotPlausible',
                            },
                            {
                              TI_texttableentry: 'TI_F_728',
                              interval: '728',
                              texttableentry: 'ElectronicalThermostateValveTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_729',
                              interval: '729',
                              texttableentry: 'ElectronicControlUnitHardwareFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_730',
                              interval: '730',
                              texttableentry: 'ElectronicalThermostateValveMotorError',
                            },
                            {
                              TI_texttableentry: 'TI_F_731',
                              interval: '731',
                              texttableentry: 'ElectronicalThermostateValveClosingError',
                            },
                            {
                              TI_texttableentry: 'TI_F_732',
                              interval: '732',
                              texttableentry: 'ElectronicalThermostateCriticalLowBattery',
                            },
                            {
                              TI_texttableentry: 'TI_F_733',
                              interval: '733',
                              texttableentry: 'FloorHeatingThermostateInletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_734',
                              interval: '734',
                              texttableentry: 'FloorHeatingThermostateSecondaryTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_735',
                              interval: '735',
                              texttableentry: 'FloorHeatingThermostateExternalEnvironmentSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_736',
                              interval: '736',
                              texttableentry: 'ClimateSensorTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_737',
                              interval: '737',
                              texttableentry: 'EnergyStorageTemperatureDrift',
                            },
                            {
                              TI_texttableentry: 'TI_F_738',
                              interval: '738',
                              texttableentry: 'OpenThermDeviceBlockedBySystemConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_739',
                              interval: '739',
                              texttableentry: 'LostCommunicationCanOpenBox',
                            },
                            {
                              TI_texttableentry: 'TI_F_740',
                              interval: '740',
                              texttableentry: 'MainRelayControlCircuitFeedbackSignalError',
                            },
                            {
                              TI_texttableentry: 'TI_F_741',
                              interval: '741',
                              texttableentry: 'PyroFuseControlCircuitFeedbackSignalError',
                            },
                            {
                              TI_texttableentry: 'TI_F_742',
                              interval: '742',
                              texttableentry: 'WatchdogControlCircuitFeedbackSignalError',
                            },
                            {
                              TI_texttableentry: 'TI_F_743',
                              interval: '743',
                              texttableentry: 'RefrigerationCircuitAvailabilityNotInitialized',
                            },
                            {
                              TI_texttableentry: 'TI_F_744',
                              interval: '744',
                              texttableentry: 'UnsupportedConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_745',
                              interval: '745',
                              texttableentry: 'NoMatchingApplication',
                            },
                            {
                              TI_texttableentry: 'TI_F_746',
                              interval: '746',
                              texttableentry: 'ApplicationFlashingFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_747',
                              interval: '747',
                              texttableentry: 'InternalHumanMachineInterfaceError',
                            },
                            {
                              TI_texttableentry: 'TI_F_748',
                              interval: '748',
                              texttableentry: 'DisplayDriverTouchFoilIssue',
                            },
                            {
                              TI_texttableentry: 'TI_F_749',
                              interval: '749',
                              texttableentry: 'FirmwareCompatibilityIssue',
                            },
                            {
                              TI_texttableentry: 'TI_F_750',
                              interval: '750',
                              texttableentry: 'ShortCircuitControllerBoardTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_751',
                              interval: '751',
                              texttableentry: 'InterruptionControllerBoardTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_752',
                              interval: '752',
                              texttableentry: 'GridFrequencyTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_753',
                              interval: '753',
                              texttableentry: 'GridFrequencyTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_754',
                              interval: '754',
                              texttableentry: 'GridVoltageTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_755',
                              interval: '755',
                              texttableentry: 'PowerUnitBatteryVoltageError',
                            },
                            {
                              TI_texttableentry: 'TI_F_756',
                              interval: '756',
                              texttableentry: 'InverterInputBWrongPolarity',
                            },
                            {
                              TI_texttableentry: 'TI_F_757',
                              interval: '757',
                              texttableentry: 'InverterInputCWrongPolarity',
                            },
                            {
                              TI_texttableentry: 'TI_F_758',
                              interval: '758',
                              texttableentry: 'DualHtsVersionIncompatible',
                            },
                            {
                              TI_texttableentry: 'TI_F_759',
                              interval: '759',
                              texttableentry: 'DualHtsNoBranding',
                            },
                            {
                              TI_texttableentry: 'TI_F_760',
                              interval: '760',
                              texttableentry: 'DualHtsOemVariantMismatch',
                            },
                            {
                              TI_texttableentry: 'TI_F_761',
                              interval: '761',
                              texttableentry: 'InverterInputAWrongPolarity',
                            },
                            {
                              TI_texttableentry: 'TI_F_762',
                              interval: '762',
                              texttableentry: 'LowWaterCutOff',
                            },
                            {
                              TI_texttableentry: 'TI_F_763',
                              interval: '763',
                              texttableentry: 'GasPressureHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_764',
                              interval: '764',
                              texttableentry: 'LagDeviceDtcReported',
                            },
                            {
                              TI_texttableentry: 'TI_F_765',
                              interval: '765',
                              texttableentry: 'LostCommunicationLagDevice',
                            },
                            {
                              TI_texttableentry: 'TI_F_766',
                              interval: '766',
                              texttableentry: 'FlueGasTemperatureDeratingWarningThresholdReached',
                            },
                            {
                              TI_texttableentry: 'TI_F_767',
                              interval: '767',
                              texttableentry: 'FlueGasTemperatureDeratingErrorThresholdReached',
                            },
                            {
                              TI_texttableentry: 'TI_F_768',
                              interval: '768',
                              texttableentry: 'ShortCircuitCondensateDetectionSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_769',
                              interval: '769',
                              texttableentry: 'InterruptionCondensateDetectionSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_770',
                              interval: '770',
                              texttableentry: 'InterruptionSecondaryOutletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_771',
                              interval: '771',
                              texttableentry: 'ShortCircuitSecondaryOutletTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_772',
                              interval: '772',
                              texttableentry: 'InterruptionCompressorOilTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_773',
                              interval: '773',
                              texttableentry: 'ShortCircuitCompressorOilTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_774',
                              interval: '774',
                              texttableentry:
                                'InterruptionEnhancedVapourInjectionTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_775',
                              interval: '775',
                              texttableentry:
                                'ShortCircuitEnhancedVapourInjectionTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_776',
                              interval: '776',
                              texttableentry: 'InterruptionReceiverTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_777',
                              interval: '777',
                              texttableentry: 'ShortCircuitReceiverTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_778',
                              interval: '778',
                              texttableentry: 'InterruptionCompressorMotorChamberTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_779',
                              interval: '779',
                              texttableentry: 'ShortCircuitCompressorMotorChamberTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_780',
                              interval: '780',
                              texttableentry: 'RelayTestNotExecuted',
                            },
                            {
                              TI_texttableentry: 'TI_F_781',
                              interval: '781',
                              texttableentry: 'RelayTestError',
                            },
                            {
                              TI_texttableentry: 'TI_F_782',
                              interval: '782',
                              texttableentry: 'FanIntermediateCircuitVoltageLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_783',
                              interval: '783',
                              texttableentry: 'GeneralFanError',
                            },
                            {
                              TI_texttableentry: 'TI_F_784',
                              interval: '784',
                              texttableentry: 'AdditionalElectricHeaterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_785',
                              interval: '785',
                              texttableentry: 'ExternalLockTriggeredFanShutdownButNotConfigured',
                            },
                            {
                              TI_texttableentry: 'TI_F_786',
                              interval: '786',
                              texttableentry: 'FailedDeviceAssignmentToSrcRoom',
                            },
                            {
                              TI_texttableentry: 'TI_F_787',
                              interval: '787',
                              texttableentry: 'PowerUnitIslandOverload',
                            },
                            {
                              TI_texttableentry: 'TI_F_788',
                              interval: '788',
                              texttableentry: 'InterruptionFourThreeWayValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_789',
                              interval: '789',
                              texttableentry: 'ShortCircuitFourThreeWayValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_790',
                              interval: '790',
                              texttableentry: 'MechanicalFailureFourThreeWayValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_791',
                              interval: '791',
                              texttableentry: 'FailureElectricalHeaterPhaseOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_792',
                              interval: '792',
                              texttableentry: 'FailureElectricalHeaterPhaseTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_793',
                              interval: '793',
                              texttableentry: 'FailureElectricalHeaterPhaseThree',
                            },
                            {
                              TI_texttableentry: 'TI_F_794',
                              interval: '794',
                              texttableentry: 'InterruptionElectricalHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_795',
                              interval: '795',
                              texttableentry: 'ShortCircuitDomesticHotWaterCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_796',
                              interval: '796',
                              texttableentry: 'InterruptionDomesticHotWaterCirculationPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_797',
                              interval: '797',
                              texttableentry: 'MechanicalFailureCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_798',
                              interval: '798',
                              texttableentry: 'MechanicalFailureMixerTwoCircuitPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_799',
                              interval: '799',
                              texttableentry: 'ElectricalFailureCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_800',
                              interval: '800',
                              texttableentry: 'ElectricalFailureMixerTwoCircuitPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_801',
                              interval: '801',
                              texttableentry: 'FailureRefrigerationCircuitFourWayValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_802',
                              interval: '802',
                              texttableentry: 'InterruptionRefrigerationCircuitFourWayValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_803',
                              interval: '803',
                              texttableentry: 'ShortCircuitPrimaryHeatExchangerBaseHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_804',
                              interval: '804',
                              texttableentry: 'InterruptionPrimaryHeatExchangerBaseHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_805',
                              interval: '805',
                              texttableentry: 'ShortCircuitPrimaryCircuitFanOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_806',
                              interval: '806',
                              texttableentry: 'InterruptionPrimaryCircuitFanOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_807',
                              interval: '807',
                              texttableentry: 'InterruptionTachoSignalPrimaryCircuitFanOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_808',
                              interval: '808',
                              texttableentry: 'FailurePrimaryCircuitFanOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_809',
                              interval: '809',
                              texttableentry: 'ShortCircuitPrimaryCircuitFanTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_810',
                              interval: '810',
                              texttableentry: 'InterruptionPrimaryCircuitFanTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_811',
                              interval: '811',
                              texttableentry: 'InterruptionTachoSignalPrimaryCircuitFanTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_812',
                              interval: '812',
                              texttableentry: 'FailurePrimaryCircuitFanTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_813',
                              interval: '813',
                              texttableentry: 'ShortCircuitCrankCaseHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_814',
                              interval: '814',
                              texttableentry: 'InterruptionCrankCaseHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_815',
                              interval: '815',
                              texttableentry: 'ShortCircuitHumidityProtectionSensorMixerOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_816',
                              interval: '816',
                              texttableentry: 'OpenLoadDetectionHumidityProtectionSensorMixerOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_817',
                              interval: '817',
                              texttableentry: 'ShortCircuitHumidityProtectionSensorMixerTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_818',
                              interval: '818',
                              texttableentry: 'OpenLoadDetectionHumidityProtectionSensorMixerTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_819',
                              interval: '819',
                              texttableentry: 'InterruptionExpansionValveOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_820',
                              interval: '820',
                              texttableentry: 'InterruptionExpansionValveTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_821',
                              interval: '821',
                              texttableentry: 'ShortCircuitMixerTwoCircuitPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_822',
                              interval: '822',
                              texttableentry: 'InterruptionMixerTwoCircuitPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_823',
                              interval: '823',
                              texttableentry: 'ShortCircuitElectronicExpansionValveOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_824',
                              interval: '824',
                              texttableentry: 'ShortCircuitElectronicExpansionValveTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_825',
                              interval: '825',
                              texttableentry: 'ShortCircuitCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_826',
                              interval: '826',
                              texttableentry: 'InterruptionCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_827',
                              interval: '827',
                              texttableentry: 'OverHeatingTemperatureSafetySwitchActivated',
                            },
                            {
                              TI_texttableentry: 'TI_F_828',
                              interval: '828',
                              texttableentry: 'HydraulicFilterMissing',
                            },
                            {
                              TI_texttableentry: 'TI_F_829',
                              interval: '829',
                              texttableentry: 'StrongContaminationHydraulicFilter',
                            },
                            {
                              TI_texttableentry: 'TI_F_830',
                              interval: '830',
                              texttableentry: 'InverterCompressorCurrentSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_831',
                              interval: '831',
                              texttableentry: 'InverterPowerFactorCorrectionCurrentSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_832',
                              interval: '832',
                              texttableentry: 'InverterBridgeTemperatureSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_833',
                              interval: '833',
                              texttableentry: 'InverterPowerFactorCorrectionTemperatureSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_834',
                              interval: '834',
                              texttableentry: 'InverterAcGridPhaseLostFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_835',
                              interval: '835',
                              texttableentry: 'InverterCompressorCodeMismatch',
                            },
                            {
                              TI_texttableentry: 'TI_F_836',
                              interval: '836',
                              texttableentry: 'InverterBridgeOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_837',
                              interval: '837',
                              texttableentry: 'InverterCompressorLostOfPhase',
                            },
                            {
                              TI_texttableentry: 'TI_F_838',
                              interval: '838',
                              texttableentry: 'InverterControlFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_839',
                              interval: '839',
                              texttableentry: 'InverterLockedRotorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_840',
                              interval: '840',
                              texttableentry: 'InverterGroundFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_841',
                              interval: '841',
                              texttableentry: 'InverterCompressorOverLoad',
                            },
                            {
                              TI_texttableentry: 'TI_F_842',
                              interval: '842',
                              texttableentry: 'InverterBridgeShortCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_843',
                              interval: '843',
                              texttableentry: 'InverterHardwarePowerFactorCorrectionOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_844',
                              interval: '844',
                              texttableentry: 'InverterReferenceVoltageFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_845',
                              interval: '845',
                              texttableentry: 'InverterWrongRegisterAddress',
                            },
                            {
                              TI_texttableentry: 'TI_F_846',
                              interval: '846',
                              texttableentry: 'InverterCompressorSpeedReverseError',
                            },
                            {
                              TI_texttableentry: 'TI_F_847',
                              interval: '847',
                              texttableentry: 'InverterCurrentNotChange',
                            },
                            {
                              TI_texttableentry: 'TI_F_848',
                              interval: '848',
                              texttableentry: 'InverterCurrentChangeToFast',
                            },
                            {
                              TI_texttableentry: 'TI_F_849',
                              interval: '849',
                              texttableentry: 'InverterSafetyTorqueOffOneFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_850',
                              interval: '850',
                              texttableentry: 'InverterSafetyTorqueOffTwoFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_851',
                              interval: '851',
                              texttableentry: 'InverterSafetyTorqueOffThreeFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_852',
                              interval: '852',
                              texttableentry: 'InverterSafetyTorqueOffOneSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_853',
                              interval: '853',
                              texttableentry: 'InverterSafetyTorqueOffTwoSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_854',
                              interval: '854',
                              texttableentry: 'InverterSafetyTorqueOffThreeSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_855',
                              interval: '855',
                              texttableentry: 'InverterOverVoltageProtectionFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_856',
                              interval: '856',
                              texttableentry: 'InverterHardwareDcLinkOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_857',
                              interval: '857',
                              texttableentry: 'InverterSoftwareDcLinkOverCurrent',
                            },
                            {
                              TI_texttableentry: 'TI_F_858',
                              interval: '858',
                              texttableentry: 'InverterDcLinkCurrentSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_859',
                              interval: '859',
                              texttableentry: 'InverterSpeedFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_860',
                              interval: '860',
                              texttableentry: 'InverterUnderTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_861',
                              interval: '861',
                              texttableentry: 'InverterMicroElectronicsFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_862',
                              interval: '862',
                              texttableentry: 'InverterInternalFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_863',
                              interval: '863',
                              texttableentry: 'StartAbortedIgnitionSparkError',
                            },
                            {
                              TI_texttableentry: 'TI_F_864',
                              interval: '864',
                              texttableentry: 'DefrostingUnsuccessful',
                            },
                            {
                              TI_texttableentry: 'TI_F_865',
                              interval: '865',
                              texttableentry: 'HighPressureShutOffRefrigerantCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_866',
                              interval: '866',
                              texttableentry: 'LowPressureShutOffRefrigerantCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_867',
                              interval: '867',
                              texttableentry: 'ActivatedSafetyValveHydraulicCircuit',
                            },
                            {
                              TI_texttableentry: 'TI_F_868',
                              interval: '868',
                              texttableentry: 'FailureCommunicationPreheaterModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_869',
                              interval: '869',
                              texttableentry: 'FailureCommunicationPostheaterModule',
                            },
                            {
                              TI_texttableentry: 'TI_F_870',
                              interval: '870',
                              texttableentry: 'PreheaterTwentyFourVoltPowerSupplyFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_871',
                              interval: '871',
                              texttableentry: 'PostheaterTwentyFourVoltPowerSupplyFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_872',
                              interval: '872',
                              texttableentry: 'InternalTwentyFourVoltPowerSupplyMonitoringFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_873',
                              interval: '873',
                              texttableentry: 'InterruptionCommonFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_874',
                              interval: '874',
                              texttableentry: 'ShortCircuitCommonFlowTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_875',
                              interval: '875',
                              texttableentry: 'FailureCommunicationToLeadDevice',
                            },
                            {
                              TI_texttableentry: 'TI_F_876',
                              interval: '876',
                              texttableentry: 'InterruptionCombinedVolumeFlowAndTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_877',
                              interval: '877',
                              texttableentry: 'ShortCircuitOutdoorMiddleCoilTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_878',
                              interval: '878',
                              texttableentry: 'InterruptionOutdoorMiddleCoilTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_879',
                              interval: '879',
                              texttableentry:
                                'ShortCircuitSecondaryHeatExchangerVaporPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_880',
                              interval: '880',
                              texttableentry:
                                'InterruptionSecondaryHeatExchangerVaporPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_881',
                              interval: '881',
                              texttableentry: 'InverterSafetyOperationalShutDown',
                            },
                            {
                              TI_texttableentry: 'TI_F_882',
                              interval: '882',
                              texttableentry: 'GasOutputPressureTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_883',
                              interval: '883',
                              texttableentry: 'GasValveCheckGasValveElectronics',
                            },
                            {
                              TI_texttableentry: 'TI_F_884',
                              interval: '884',
                              texttableentry: 'GasValveCheckNoGasValvePressureIncrease',
                            },
                            {
                              TI_texttableentry: 'TI_F_885',
                              interval: '885',
                              texttableentry: 'GasValveCheckVTwoTestNotPassed',
                            },
                            {
                              TI_texttableentry: 'TI_F_886',
                              interval: '886',
                              texttableentry: 'GasValveCheckNoGasValvePressureDecrease',
                            },
                            {
                              TI_texttableentry: 'TI_F_887',
                              interval: '887',
                              texttableentry: 'GasValveCheckVOneTestNotPassed',
                            },
                            {
                              TI_texttableentry: 'TI_F_888',
                              interval: '888',
                              texttableentry: 'OxygenProbeControllerCommunication',
                            },
                            {
                              TI_texttableentry: 'TI_F_889',
                              interval: '889',
                              texttableentry: 'OxygenProbeMonitoringVsTest',
                            },
                            {
                              TI_texttableentry: 'TI_F_890',
                              interval: '890',
                              texttableentry: 'OxygenProbeMonitoringVsOutOfRange',
                            },
                            {
                              TI_texttableentry: 'TI_F_891',
                              interval: '891',
                              texttableentry: 'OxygenProbeCalibrationNotReady',
                            },
                            {
                              TI_texttableentry: 'TI_F_892',
                              interval: '892',
                              texttableentry: 'OxygenProbeCalibrationDifference',
                            },
                            {
                              TI_texttableentry: 'TI_F_893',
                              interval: '893',
                              texttableentry: 'OxygenProbeCalibrationOutOfRange',
                            },
                            {
                              TI_texttableentry: 'TI_F_894',
                              interval: '894',
                              texttableentry: 'OxygenProbeMonitoringMeasuringCellShunt',
                            },
                            {
                              TI_texttableentry: 'TI_F_895',
                              interval: '895',
                              texttableentry:
                                'OxygenProbeMonitoringMeasuringCellInternalResistance',
                            },
                            {
                              TI_texttableentry: 'TI_F_896',
                              interval: '896',
                              texttableentry: 'SafetyChainInputOneLockout',
                            },
                            {
                              TI_texttableentry: 'TI_F_897',
                              interval: '897',
                              texttableentry: 'SafetyChainInputTwoLockout',
                            },
                            {
                              TI_texttableentry: 'TI_F_898',
                              interval: '898',
                              texttableentry: 'OutdoorAirTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_899',
                              interval: '899',
                              texttableentry: 'OutdoorAirHumiditySensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_900',
                              interval: '900',
                              texttableentry: 'ExtractAirTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_901',
                              interval: '901',
                              texttableentry: 'ExtractAirHumiditySensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_902',
                              interval: '902',
                              texttableentry: 'SupplyAirTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_903',
                              interval: '903',
                              texttableentry: 'SupplyAirHumiditySensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_904',
                              interval: '904',
                              texttableentry: 'ExhaustAirTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_905',
                              interval: '905',
                              texttableentry: 'ExhaustAirHumiditySensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_906',
                              interval: '906',
                              texttableentry: 'PowerMismatchOutdoorToIndoorUnit',
                            },
                            {
                              TI_texttableentry: 'TI_F_907',
                              interval: '907',
                              texttableentry: 'ShortCircuitFanHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_908',
                              interval: '908',
                              texttableentry: 'InterruptionFanHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_909',
                              interval: '909',
                              texttableentry: 'ElectricalEnergyMatrixInvalidValue',
                            },
                            {
                              TI_texttableentry: 'TI_F_910',
                              interval: '910',
                              texttableentry: 'MultipleLeadDeviceCollisionDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_911',
                              interval: '911',
                              texttableentry: 'InconsistentVentilationVolumeFlowConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_912',
                              interval: '912',
                              texttableentry: 'InverterAmbientTemperatureSensorFault',
                            },
                            {
                              TI_texttableentry: 'TI_F_913',
                              interval: '913',
                              texttableentry: 'InverterAmbientTemperatureProtectionActive',
                            },
                            {
                              TI_texttableentry: 'TI_F_914',
                              interval: '914',
                              texttableentry: 'InverterHeatSinkOverTemperatureProtection',
                            },
                            {
                              TI_texttableentry: 'TI_F_915',
                              interval: '915',
                              texttableentry: 'ShortCircuitInverterHeatSinkOverTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_916',
                              interval: '916',
                              texttableentry: 'InterruptionCircuitInverterHeatSinkOverTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_917',
                              interval: '917',
                              texttableentry: 'SignalCompareInternalPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_918',
                              interval: '918',
                              texttableentry: 'SignalCompareInternalEmergencyPowerSupply',
                            },
                            {
                              TI_texttableentry: 'TI_F_919',
                              interval: '919',
                              texttableentry: 'SignalCompareInternalPyrofuseCapacitorVoltage',
                            },
                            {
                              TI_texttableentry: 'TI_F_920',
                              interval: '920',
                              texttableentry: 'ExternalSafetyEquipmentOneFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_921',
                              interval: '921',
                              texttableentry: 'ExternalSafetyEquipmentTwoFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_922',
                              interval: '922',
                              texttableentry: 'ExternalSafetyEquipmentThreeFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_923',
                              interval: '923',
                              texttableentry: 'ElectricalEnergyMatrixMeterOneDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_924',
                              interval: '924',
                              texttableentry: 'ElectricalEnergyMatrixMeterTwoDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_925',
                              interval: '925',
                              texttableentry: 'ElectricalEnergyMatrixMeterThreeDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_926',
                              interval: '926',
                              texttableentry: 'ElectricalEnergyMatrixMeterFourDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_927',
                              interval: '927',
                              texttableentry: 'ElectricalEnergyMatrixMeterFiveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_928',
                              interval: '928',
                              texttableentry: 'ElectricalEnergyMatrixMeterSixDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_929',
                              interval: '929',
                              texttableentry: 'ElectricalEnergyMatrixMeterSevenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_930',
                              interval: '930',
                              texttableentry: 'ElectricalEnergyMatrixMeterEightDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_931',
                              interval: '931',
                              texttableentry: 'ElectricalEnergyMatrixMeterNineDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_932',
                              interval: '932',
                              texttableentry: 'ElectricalEnergyMatrixMeterTenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_933',
                              interval: '933',
                              texttableentry: 'ElectricalEnergyMatrixMeterElevenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_934',
                              interval: '934',
                              texttableentry: 'ElectricalEnergyMatrixMeterTwelveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_935',
                              interval: '935',
                              texttableentry: 'ElectricalEnergyMatrixMeterThirteenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_936',
                              interval: '936',
                              texttableentry: 'ElectricalEnergyMatrixMeterFourteenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_937',
                              interval: '937',
                              texttableentry: 'ElectricalEnergyMatrixMeterFifteenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_938',
                              interval: '938',
                              texttableentry: 'ElectricalEnergyMatrixInverterOneDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_939',
                              interval: '939',
                              texttableentry: 'ElectricalEnergyMatrixInverterTwoDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_940',
                              interval: '940',
                              texttableentry: 'ElectricalEnergyMatrixInverterThreeDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_941',
                              interval: '941',
                              texttableentry: 'ElectricalEnergyMatrixInverterFourDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_942',
                              interval: '942',
                              texttableentry: 'ElectricalEnergyMatrixInverterFiveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_943',
                              interval: '943',
                              texttableentry: 'ElectricalEnergyMatrixInverterSixDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_944',
                              interval: '944',
                              texttableentry: 'ElectricalEnergyMatrixConsumerOneDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_945',
                              interval: '945',
                              texttableentry: 'ElectricalEnergyMatrixConsumerTwoDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_946',
                              interval: '946',
                              texttableentry: 'ElectricalEnergyMatrixConsumerThreeDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_947',
                              interval: '947',
                              texttableentry: 'ElectricalEnergyMatrixConsumerFourDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_948',
                              interval: '948',
                              texttableentry: 'ElectricalEnergyMatrixConsumerFiveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_949',
                              interval: '949',
                              texttableentry: 'ElectricalEnergyMatrixConsumerSixDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_950',
                              interval: '950',
                              texttableentry: 'ElectricalEnergyMatrixConsumerSevenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_951',
                              interval: '951',
                              texttableentry: 'ElectricalEnergyMatrixConsumerEightDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_952',
                              interval: '952',
                              texttableentry: 'ElectricalEnergyMatrixConsumerNineDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_953',
                              interval: '953',
                              texttableentry: 'ElectricalEnergyMatrixConsumerTenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_954',
                              interval: '954',
                              texttableentry: 'ElectricalEnergyMatrixConsumerElevenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_955',
                              interval: '955',
                              texttableentry: 'ElectricalEnergyMatrixConsumerTwelveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_956',
                              interval: '956',
                              texttableentry: 'ElectricalEnergyMatrixConsumerThirteenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_957',
                              interval: '957',
                              texttableentry: 'ElectricalEnergyMatrixConsumerFourteenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_958',
                              interval: '958',
                              texttableentry: 'ElectricalEnergyMatrixConsumerFifteenDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_959',
                              interval: '959',
                              texttableentry: 'ElectricalEnergyMatrixProducerOneDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_960',
                              interval: '960',
                              texttableentry: 'ElectricalEnergyMatrixProducerTwoDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_961',
                              interval: '961',
                              texttableentry: 'ElectricalEnergyMatrixProducerThreeDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_962',
                              interval: '962',
                              texttableentry: 'ElectricalEnergyMatrixProducerFourDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_963',
                              interval: '963',
                              texttableentry: 'ElectricalEnergyMatrixProducerFiveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_964',
                              interval: '964',
                              texttableentry: 'ElectricalEnergyMatrixProducerSixDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_965',
                              interval: '965',
                              texttableentry: 'ElectricalEnergyMatrixStorageOneDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_966',
                              interval: '966',
                              texttableentry: 'ElectricalEnergyMatrixStorageTwoDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_967',
                              interval: '967',
                              texttableentry: 'ElectricalEnergyMatrixStorageThreeDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_968',
                              interval: '968',
                              texttableentry: 'ElectricalEnergyMatrixStorageFourDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_969',
                              interval: '969',
                              texttableentry: 'ElectricalEnergyMatrixStorageFiveDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_970',
                              interval: '970',
                              texttableentry: 'ElectricalEnergyMatrixStorageSixDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_971',
                              interval: '971',
                              texttableentry: 'GasVolumeFactoryOffsetNotSet',
                            },
                            {
                              TI_texttableentry: 'TI_F_972',
                              interval: '972',
                              texttableentry: 'FanSpeedTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_973',
                              interval: '973',
                              texttableentry: 'PreHeaterNoHeatOperation',
                            },
                            {
                              TI_texttableentry: 'TI_F_974',
                              interval: '974',
                              texttableentry: 'BypassMotorNotMoving',
                            },
                            {
                              TI_texttableentry: 'TI_F_975',
                              interval: '975',
                              texttableentry: 'FuelCellPowerConditioningSystemInputVoltageDropFour',
                            },
                            {
                              TI_texttableentry: 'TI_F_976',
                              interval: '976',
                              texttableentry: 'FuelCellInverterPBoardFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_977',
                              interval: '977',
                              texttableentry: 'FuelCellHydrogenFlowMeterFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_978',
                              interval: '978',
                              texttableentry: 'SensorDataInsufficientForAutomaticMode',
                            },
                            {
                              TI_texttableentry: 'TI_F_979',
                              interval: '979',
                              texttableentry: 'ThermostatInputDoubleConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_980',
                              interval: '980',
                              texttableentry:
                                'DomesticHotWaterLoadingTerminatedInsufficientVolumeFlow',
                            },
                            {
                              TI_texttableentry: 'TI_F_981',
                              interval: '981',
                              texttableentry:
                                'DomesticHotWaterLoadingTerminatedVolumeFlowDroppedBelowThreshold',
                            },
                            {
                              TI_texttableentry: 'TI_F_982',
                              interval: '982',
                              texttableentry: 'DryRunCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_983',
                              interval: '983',
                              texttableentry: 'InverterFailurePersistentMemory',
                            },
                            {
                              TI_texttableentry: 'TI_F_984',
                              interval: '984',
                              texttableentry: 'ElectricalFailureElectronicExpansionValveOneMotor',
                            },
                            {
                              TI_texttableentry: 'TI_F_985',
                              interval: '985',
                              texttableentry: 'ElectricalFailureElectronicExpansionValveTwoMotor',
                            },
                            {
                              TI_texttableentry: 'TI_F_986',
                              interval: '986',
                              texttableentry: 'BurnerControlUnitParameterMismatch',
                            },
                            {
                              TI_texttableentry: 'TI_F_987',
                              interval: '987',
                              texttableentry: 'SignalEvaluationExhaustFlapFeedback',
                            },
                            {
                              TI_texttableentry: 'TI_F_988',
                              interval: '988',
                              texttableentry: 'SignalEvaluationGasPressureSwitch',
                            },
                            {
                              TI_texttableentry: 'TI_F_989',
                              interval: '989',
                              texttableentry: 'SignalEvaluationIgnitionRelay',
                            },
                            {
                              TI_texttableentry: 'TI_F_990',
                              interval: '990',
                              texttableentry: 'ShortCircuitHydraulicSeperatorTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_991',
                              interval: '991',
                              texttableentry: 'InterruptionHydraulicSeperatorTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_992',
                              interval: '992',
                              texttableentry: 'ShortCircuitHeatingCoolingBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_993',
                              interval: '993',
                              texttableentry: 'InterruptionHeatingCoolingBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_994',
                              interval: '994',
                              texttableentry: 'ShortCircuitHeatingBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_995',
                              interval: '995',
                              texttableentry: 'InterruptionHeatingBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_996',
                              interval: '996',
                              texttableentry: 'ShortCircuitCoolingBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_997',
                              interval: '997',
                              texttableentry: 'InterruptionCoolingBufferTemperatureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_998',
                              interval: '998',
                              texttableentry: 'CombinedVolumeFlowAndTemperatureSensorTimeOut',
                            },
                            {
                              TI_texttableentry: 'TI_F_999',
                              interval: '999',
                              texttableentry: 'FailureCommunicationHIO',
                            },
                            {
                              TI_texttableentry: 'TI_F_1000',
                              interval: '1000',
                              texttableentry: 'ShowtimeBaby',
                            },
                            {
                              TI_texttableentry: 'TI_F_1001',
                              interval: '1001',
                              texttableentry: 'OxygenProbeNotCalibrated',
                            },
                            {
                              TI_texttableentry: 'TI_F_1002',
                              interval: '1002',
                              texttableentry: 'OxygenProbeCurrentValueCompensationOffsetParameter',
                            },
                            {
                              TI_texttableentry: 'TI_F_1003',
                              interval: '1003',
                              texttableentry: 'OxygenProbeCurrentValueCompensationOffsetBoundary',
                            },
                            {
                              TI_texttableentry: 'TI_F_1004',
                              interval: '1004',
                              texttableentry: 'OxygenContentLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_1005',
                              interval: '1005',
                              texttableentry: 'FiniteStateMachineIgnitionRelayFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1006',
                              interval: '1006',
                              texttableentry: 'StartupFailureCounterRefrigerantCircuitExceeded',
                            },
                            {
                              TI_texttableentry: 'TI_F_1007',
                              interval: '1007',
                              texttableentry: 'RefrigerantCircuitLocked',
                            },
                            {
                              TI_texttableentry: 'TI_F_1008',
                              interval: '1008',
                              texttableentry: 'NumberOfSupportedLagDevicesExceeded',
                            },
                            {
                              TI_texttableentry: 'TI_F_1009',
                              interval: '1009',
                              texttableentry: 'FailureCrankCaseHeater',
                            },
                            {
                              TI_texttableentry: 'TI_F_1010',
                              interval: '1010',
                              texttableentry: 'FailureHydraulicWaterPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_1011',
                              interval: '1011',
                              texttableentry: 'FailureCompressorOutletPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_1012',
                              interval: '1012',
                              texttableentry: 'FailureCompressorInletPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_1013',
                              interval: '1013',
                              texttableentry: 'FailureConfigurationOutdoorUnitMissing',
                            },
                            {
                              TI_texttableentry: 'TI_F_1014',
                              interval: '1014',
                              texttableentry: 'FailureUndefinedOutdoorModel',
                            },
                            {
                              TI_texttableentry: 'TI_F_1015',
                              interval: '1015',
                              texttableentry: 'FailureMismatchHardwareTypeOutdoorUnit',
                            },
                            {
                              TI_texttableentry: 'TI_F_1016',
                              interval: '1016',
                              texttableentry: 'ReturnTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_1017',
                              interval: '1017',
                              texttableentry: 'SecondaryOutletTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_1018',
                              interval: '1018',
                              texttableentry:
                                'SecondaryHeatExchangerVaporPressureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_1019',
                              interval: '1019',
                              texttableentry:
                                'SecondaryHeatExchangerLiquidTemperatureSensorNotAvailable',
                            },
                            {
                              TI_texttableentry: 'TI_F_1020',
                              interval: '1020',
                              texttableentry: 'InverterOverTemperature',
                            },
                            {
                              TI_texttableentry: 'TI_F_1021',
                              interval: '1021',
                              texttableentry: 'GridSupportConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_1022',
                              interval: '1022',
                              texttableentry: 'EnergyMeter',
                            },
                            {
                              TI_texttableentry: 'TI_F_1023',
                              interval: '1023',
                              texttableentry: 'GridVoltagePhaseThreeTooLow',
                            },
                            {
                              TI_texttableentry: 'TI_F_1024',
                              interval: '1024',
                              texttableentry: 'GridVoltagePhaseOneTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_1025',
                              interval: '1025',
                              texttableentry: 'GridVoltagePhaseTwoTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_1026',
                              interval: '1026',
                              texttableentry: 'GridVoltagePhaseThreeTooHigh',
                            },
                            {
                              TI_texttableentry: 'TI_F_1027',
                              interval: '1027',
                              texttableentry: 'InverterSelfTestFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_1028',
                              interval: '1028',
                              texttableentry: 'PhotovoltaicsInput',
                            },
                            {
                              TI_texttableentry: 'TI_F_1029',
                              interval: '1029',
                              texttableentry: 'BatteryInput',
                            },
                            {
                              TI_texttableentry: 'TI_F_1030',
                              interval: '1030',
                              texttableentry: 'BalancingFailed',
                            },
                            {
                              TI_texttableentry: 'TI_F_1031',
                              interval: '1031',
                              texttableentry: 'CollectiveGridError',
                            },
                            {
                              TI_texttableentry: 'TI_F_1032',
                              interval: '1032',
                              texttableentry: 'FailureCommunicationEEBUS',
                            },
                            {
                              TI_texttableentry: 'TI_F_1033',
                              interval: '1033',
                              texttableentry: 'ConfigurationDC',
                            },
                            {
                              TI_texttableentry: 'TI_F_1034',
                              interval: '1034',
                              texttableentry: 'CanExternalCommunicationException',
                            },
                            {
                              TI_texttableentry: 'TI_F_1035',
                              interval: '1035',
                              texttableentry: 'CanInternalCommunicationException',
                            },
                            {
                              TI_texttableentry: 'TI_F_1036',
                              interval: '1036',
                              texttableentry: 'CanBatteryCommunicationException',
                            },
                            {
                              TI_texttableentry: 'TI_F_1037',
                              interval: '1037',
                              texttableentry: 'CSCCountNoneInstalled',
                            },
                            {
                              TI_texttableentry: 'TI_F_1038',
                              interval: '1038',
                              texttableentry: 'CSCCountMoreInstalled',
                            },
                            {
                              TI_texttableentry: 'TI_F_1039',
                              interval: '1039',
                              texttableentry: 'CSCCountLessInstalled',
                            },
                            {
                              TI_texttableentry: 'TI_F_1040',
                              interval: '1040',
                              texttableentry: 'FailureReversedFlowDirectionEnergyMeter',
                            },
                            {
                              TI_texttableentry: 'TI_F_1041',
                              interval: '1041',
                              texttableentry: 'WrongInverterVariantInstalled',
                            },
                            {
                              TI_texttableentry: 'TI_F_1042',
                              interval: '1042',
                              texttableentry: 'InverterLinkVoltageDivergence',
                            },
                            {
                              TI_texttableentry: 'TI_F_1043',
                              interval: '1043',
                              texttableentry: 'EnergyMeterFunctionConfigurationMismatch',
                            },
                            {
                              TI_texttableentry: 'TI_F_1044',
                              interval: '1044',
                              texttableentry: 'EnergyMonitoringMeterDisconnection',
                            },
                            {
                              TI_texttableentry: 'TI_F_1045',
                              interval: '1045',
                              texttableentry: 'FailureExternalThermalDeviceOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_1046',
                              interval: '1046',
                              texttableentry: 'FailureExternalThermalDeviceTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_1047',
                              interval: '1047',
                              texttableentry: 'FailureExternalThermalDeviceThree',
                            },
                            {
                              TI_texttableentry: 'TI_F_1048',
                              interval: '1048',
                              texttableentry: 'FailureExternalThermalDeviceFour',
                            },
                            {
                              TI_texttableentry: 'TI_F_1049',
                              interval: '1049',
                              texttableentry: 'FailureBivalenceMixer',
                            },
                            {
                              TI_texttableentry: 'TI_F_1050',
                              interval: '1050',
                              texttableentry:
                                'ShortCircuitTemperatureSensorExternalThermalDeviceOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_1051',
                              interval: '1051',
                              texttableentry:
                                'InterruptionTemperatureSensorExternalThermalDeviceOne',
                            },
                            {
                              TI_texttableentry: 'TI_F_1052',
                              interval: '1052',
                              texttableentry:
                                'ShortCircuitTemperatureSensorExternalThermalDeviceTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_1053',
                              interval: '1053',
                              texttableentry:
                                'InterruptionTemperatureSensorExternalThermalDeviceTwo',
                            },
                            {
                              TI_texttableentry: 'TI_F_1054',
                              interval: '1054',
                              texttableentry:
                                'TemperatureSensorExternalThermalDeviceOneTemperatureThreasholdExeeded',
                            },
                            {
                              TI_texttableentry: 'TI_F_1055',
                              interval: '1055',
                              texttableentry:
                                'TemperatureSensorExternalThermalDeviceTwoTemperatureThreasholdExeeded',
                            },
                            {
                              TI_texttableentry: 'TI_F_1056',
                              interval: '1056',
                              texttableentry: 'InverterFailurePreChargeRelay',
                            },
                            {
                              TI_texttableentry: 'TI_F_1057',
                              interval: '1057',
                              texttableentry: 'FailureSecondaryHeatExchangerVaporPressureSensor',
                            },
                            {
                              TI_texttableentry: 'TI_F_1058',
                              interval: '1058',
                              texttableentry: 'SignalEvaluationAirFilter',
                            },
                            {
                              TI_texttableentry: 'TI_F_1059',
                              interval: '1059',
                              texttableentry: 'LateIgnitionPossibleFlameDeflagrationDetected',
                            },
                            {
                              TI_texttableentry: 'TI_F_1060',
                              interval: '1060',
                              texttableentry: 'OxygenProbeControllerSupervisionCellVoltageDrift',
                            },
                            {
                              TI_texttableentry: 'TI_F_1061',
                              interval: '1061',
                              texttableentry: 'OxygenProbeControllerSupervisionProbeCurrentDrift',
                            },
                            {
                              TI_texttableentry: 'TI_F_1062',
                              interval: '1062',
                              texttableentry: 'InverterDcLinkUnderVoltageFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1063',
                              interval: '1063',
                              texttableentry: 'InverterDcLinkOverVoltageFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1064',
                              interval: '1064',
                              texttableentry: 'InverterDcOverCurrentFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1065',
                              interval: '1065',
                              texttableentry: 'InverterAcGridUnderVoltageFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1066',
                              interval: '1066',
                              texttableentry: 'InverterAcGridOverVoltageFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1067',
                              interval: '1067',
                              texttableentry: 'InverterAcInputZeroCrossingFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1068',
                              interval: '1068',
                              texttableentry: 'OverheatingIndoorHeatExchangerHeatingFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1069',
                              interval: '1069',
                              texttableentry: 'OverheatingOutdoorHeatExchangerHeatingFailure',
                            },
                            {
                              TI_texttableentry: 'TI_F_1070',
                              interval: '1070',
                              texttableentry: 'FuelCellModuleCondensateBlockageDetection',
                            },
                            {
                              TI_texttableentry: 'TI_F_1071',
                              interval: '1071',
                              texttableentry: 'CoContentFuelCellExhaustGasOutOfToleranceRange',
                            },
                            {
                              TI_texttableentry: 'TI_F_1072',
                              interval: '1072',
                              texttableentry: 'FailureWaterShutoffValve',
                            },
                            {
                              TI_texttableentry: 'TI_F_1073',
                              interval: '1073',
                              texttableentry: 'FailureWaterFloorLeakDetector',
                            },
                            {
                              TI_texttableentry: 'TI_F_1074',
                              interval: '1074',
                              texttableentry: 'PressureImbalanceRefrigerantCycle',
                            },
                            {
                              TI_texttableentry: 'TI_F_1075',
                              interval: '1075',
                              texttableentry: 'SupplyAirTemperatureBelowCriticalThreshold',
                            },
                            {
                              TI_texttableentry: 'TI_F_1076',
                              interval: '1076',
                              texttableentry:
                                'CompressorStartCounterCriticalOilTemperatureExceeded',
                            },
                            {
                              TI_texttableentry: 'TI_F_1077',
                              interval: '1077',
                              texttableentry: 'FailureMinimumCompressorOnTimeViolation',
                            },
                            {
                              TI_texttableentry: 'TI_F_1078',
                              interval: '1078',
                              texttableentry:
                                'FailureFrequentInsufficientWaterFlowAtCompressorStart',
                            },
                            {
                              TI_texttableentry: 'TI_F_1079',
                              interval: '1079',
                              texttableentry: 'DefrostUnsuccessfullDueToLowWaterFlow',
                            },
                            {
                              TI_texttableentry: 'TI_F_1080',
                              interval: '1080',
                              texttableentry: 'FailureLowEvaportingTemperatureCooling',
                            },
                            {
                              TI_texttableentry: 'TI_F_1081',
                              interval: '1081',
                              texttableentry: 'FailureLowSecondaryOutletTemperatureCooling',
                            },
                            {
                              TI_texttableentry: 'TI_F_1082',
                              interval: '1082',
                              texttableentry: 'FailureTooLowCondensingTemperatureDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_F_1083',
                              interval: '1083',
                              texttableentry: 'FailureTooHighEvaporatingTemperatureCooling',
                            },
                            {
                              TI_texttableentry: 'TI_F_1084',
                              interval: '1084',
                              texttableentry: 'CompressorBlocked',
                            },
                            {
                              TI_texttableentry: 'TI_F_1085',
                              interval: '1085',
                              texttableentry: 'MechanicalFailureDomesticHotWaterTankLoadPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_1086',
                              interval: '1086',
                              texttableentry: 'ElectricalFailureDomesticHotWaterTankLoadPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_1087',
                              interval: '1087',
                              texttableentry: 'DryRunDomesticHotWaterTankLoadPump',
                            },
                            {
                              TI_texttableentry: 'TI_F_1088',
                              interval: '1088',
                              texttableentry: 'ShortCircuitDhwReturnTemperaturTankLoadSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_1089',
                              interval: '1089',
                              texttableentry: 'InterruptionDhwReturnTemperaturTankLoadSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_1090',
                              interval: '1090',
                              texttableentry: 'ShortCirucitDhwFlowTemperaturTankLoadSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_1091',
                              interval: '1091',
                              texttableentry: 'InterruptionDhwFlowTemperaturTankLoadSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_1092',
                              interval: '1092',
                              texttableentry: 'FailureInvalidOduTypeConfiguration',
                            },
                            {
                              TI_texttableentry: 'TI_F_1093',
                              interval: '1093',
                              texttableentry: 'FailureCommunicationTankLoadController',
                            },
                            {
                              TI_texttableentry: 'TI_F_1094',
                              interval: '1094',
                              texttableentry: 'NoWaterFlowDHWTankLoadSystem',
                            },
                            {
                              TI_texttableentry: 'TI_F_65533',
                              interval: '65533',
                              texttableentry: 'ViewedErrorList',
                            },
                            {
                              TI_texttableentry: 'TI_F_65534',
                              interval: '65534',
                              texttableentry: 'ErrorHasBeenConfirmed',
                            },
                          ],
                          path: 'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DTC',
                          unit: '',
                          translationid: 'TI_DtcError',
                          bitposition: '0',
                          name: 'PA_DTC',
                          value: 'NoErrorAvailable',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'HeatEngineStatus',
                          byteposition: '2',
                          dopname: '4 Bit TextTable FreezeFrameHeatEngineStatus',
                          precision: '',
                          byteLength: '4',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_HeatEnginStatu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Standby',
                              interval: '0',
                              texttableentry: 'Standby',
                            },
                            {
                              TI_texttableentry: 'TI_Startup',
                              interval: '1',
                              texttableentry: 'Startup',
                            },
                            {
                              TI_texttableentry: 'TI_Calibration',
                              interval: '2',
                              texttableentry: 'Calibration',
                            },
                            {
                              TI_texttableentry: 'TI_Active',
                              interval: '3',
                              texttableentry: 'Active',
                            },
                            {
                              TI_texttableentry: 'TI_PostRun',
                              interval: '4',
                              texttableentry: 'PostRun',
                            },
                            {
                              TI_texttableentry: 'TI_Error',
                              interval: '7',
                              texttableentry: 'Error',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatEnginStatu',
                          unit: '',
                          translationid: 'TI_HeatEngineStatus',
                          bitposition: '0',
                          name: 'PA_HeatEnginStatu',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'FuelCellStatus',
                          byteposition: '2',
                          dopname: '4 Bit TextTable FreezeFrameFuelCellStatus',
                          precision: '',
                          byteLength: '4',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_FuelCellStatu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Standby',
                              interval: '0',
                              texttableentry: 'Standby',
                            },
                            {
                              TI_texttableentry: 'TI_Startup',
                              interval: '1',
                              texttableentry: 'Startup',
                            },
                            {
                              TI_texttableentry: 'TI_Active',
                              interval: '3',
                              texttableentry: 'Active',
                            },
                            {
                              TI_texttableentry: 'TI_PostRun',
                              interval: '4',
                              texttableentry: 'PostRun',
                            },
                            {
                              TI_texttableentry: 'TI_Error',
                              interval: '7',
                              texttableentry: 'Error',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FuelCellStatu',
                          unit: '',
                          translationid: 'TI_FuelCellStatus',
                          bitposition: '4',
                          name: 'PA_FuelCellStatu',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'BoilerControllerStatus',
                          byteposition: '3',
                          dopname: '4 Bit TextTable FreezeFrameBoilerControllerStatus',
                          precision: '',
                          byteLength: '4',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_BoileContrStatu',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_Standby',
                              interval: '0',
                              texttableentry: 'Standby',
                            },
                            {
                              TI_texttableentry: 'TI_Pause',
                              interval: '1',
                              texttableentry: 'Pause',
                            },
                            {
                              TI_texttableentry: 'TI_RampUp',
                              interval: '2',
                              texttableentry: 'RampUp',
                            },
                            {
                              TI_texttableentry: 'TI_Active',
                              interval: '3',
                              texttableentry: 'Active',
                            },
                            {
                              TI_texttableentry: 'TI_PostRun',
                              interval: '4',
                              texttableentry: 'PostRun',
                            },
                            {
                              TI_texttableentry: 'TI_Error',
                              interval: '7',
                              texttableentry: 'Error',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_BoileContrStatu',
                          unit: '',
                          translationid: 'TI_BoilerControllerStatus',
                          bitposition: '0',
                          name: 'PA_BoileContrStatu',
                          value: 'Standby',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'ProductionManager',
                          byteposition: '3',
                          dopname: '4 Bit TextTable FreezeFrameProductionManager',
                          precision: '',
                          byteLength: '4',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_ProduManag',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_NoDemand',
                              interval: '0',
                              texttableentry: 'NoDemand',
                            },
                            {
                              TI_texttableentry: 'TI_HeatingDemand',
                              interval: '1',
                              texttableentry: 'HeatingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_DhwDemand',
                              interval: '2',
                              texttableentry: 'DhwDemand',
                            },
                          ],
                          path: 'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_ProduManag',
                          unit: '',
                          translationid: 'TI_ProductionManager',
                          bitposition: '4',
                          name: 'PA_ProduManag',
                          value: 'NoDemand',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'DemandManagerRequestsPartOne',
                          byteposition: '4',
                          dopname: '8 Bit Structure DemandManagerRequestPartOne',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_DemanManagRequePartOne',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'DomesticHotWater',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_DomesHotWater',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DomesHotWater',
                              unit: '',
                              translationid: 'TI_DomesticHotWater',
                              bitposition: '0',
                              name: 'PA_DomesHotWater',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitOne',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuOne',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuOne',
                              unit: '',
                              translationid: 'TI_HeatingCircuitOne',
                              bitposition: '1',
                              name: 'PA_HeatiCircuOne',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitTwo',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuTwo',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuTwo',
                              unit: '',
                              translationid: 'TI_HeatingCircuitTwo',
                              bitposition: '2',
                              name: 'PA_HeatiCircuTwo',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitThree',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuThree',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuThree',
                              unit: '',
                              translationid: 'TI_HeatingCircuitThree',
                              bitposition: '3',
                              name: 'PA_HeatiCircuThree',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitFour',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuFour',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_HeatiCircuFour',
                              unit: '',
                              translationid: 'TI_HeatingCircuitFour',
                              bitposition: '4',
                              name: 'PA_HeatiCircuFour',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'DigitalInput',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_DigitInput',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInput',
                              unit: '',
                              translationid: 'TI_DigitalInput',
                              bitposition: '5',
                              name: 'PA_DigitInput',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'DigitalInputOutputBoard',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_DigitInputOutpuBoard',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_DigitInputOutpuBoard',
                              unit: '',
                              translationid: 'TI_DigitalInputOutputBoard',
                              bitposition: '6',
                              name: 'PA_DigitInputOutpuBoard',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'AutomationGateWay',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_AutomGateWay',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne/PA_AutomGateWay',
                              unit: '',
                              translationid: 'TI_AutomationGateWay',
                              bitposition: '7',
                              name: 'PA_AutomGateWay',
                              value: 'No',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartOne',
                          unit: '',
                          translationid: 'TI_DemandManagerRequestsPartOne',
                          bitposition: '0',
                          name: 'PA_DemanManagRequePartOne',
                          value: '8',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'DemandManagerRequestsPartTwo',
                          byteposition: '5',
                          dopname: '8 Bit Structure DemandManagerRequestPartTwo',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_DemanManagRequePartTwo',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'LockDigitalInput',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_LockDigitInput',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInput',
                              unit: '',
                              translationid: 'TI_LockDigitalInput',
                              bitposition: '0',
                              name: 'PA_LockDigitInput',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'LockDigitalInputOutputBoard',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_LockDigitInputOutpuBoard',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockDigitInputOutpuBoard',
                              unit: '',
                              translationid: 'TI_LockDigitalInputOutputBoard',
                              bitposition: '1',
                              name: 'PA_LockDigitInputOutpuBoard',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'LockAutomationGateWay',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_LockAutomGateWay',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_LockAutomGateWay',
                              unit: '',
                              translationid: 'TI_LockAutomationGateWay',
                              bitposition: '2',
                              name: 'PA_LockAutomGateWay',
                              value: 'No',
                            },
                            {
                              semantic: 'RESERVED',
                              longname: 'Reserved',
                              byteposition: '0',
                              dopname: '',
                              precision: '',
                              byteLength: '5',
                              type: 'eA_UINT32',
                              shortname: 'PA_Reser',
                              constraints: '',
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo/PA_Reser',
                              unit: '',
                              translationid: 'TI_Reserved',
                              bitposition: '3',
                              name: 'PA_Reser',
                              value: '0',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DemanManagRequePartTwo',
                          unit: '',
                          translationid: 'TI_DemandManagerRequestsPartTwo',
                          bitposition: '0',
                          name: 'PA_DemanManagRequePartTwo',
                          value: '4',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'HeatingCircuitOne',
                          byteposition: '6',
                          dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_HeatiCircuOne',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitCurrentState',
                              byteposition: '0',
                              dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                              precision: '',
                              byteLength: '4',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuCurreState',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Standby',
                                  interval: '0',
                                  texttableentry: 'Standby',
                                },
                                {
                                  TI_texttableentry: 'TI_Reduced',
                                  interval: '1',
                                  texttableentry: 'Reduced',
                                },
                                {
                                  TI_texttableentry: 'TI_Normal',
                                  interval: '2',
                                  texttableentry: 'Normal',
                                },
                                {
                                  TI_texttableentry: 'TI_Comfort',
                                  interval: '3',
                                  texttableentry: 'Comfort',
                                },
                                {
                                  TI_texttableentry: 'TI_FixValue',
                                  interval: '4',
                                  texttableentry: 'FixValue',
                                },
                                {
                                  TI_texttableentry: 'TI_FrostProtection',
                                  interval: '5',
                                  texttableentry: 'FrostProtection',
                                },
                                {
                                  TI_texttableentry: 'TI_ReducedEnergySaving',
                                  interval: '6',
                                  texttableentry: 'ReducedEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_NormalEnergySaving',
                                  interval: '7',
                                  texttableentry: 'NormalEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_ComfortEnergySaving',
                                  interval: '8',
                                  texttableentry: 'ComfortEnergySaving',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_HeatiCircuCurreState',
                              unit: '',
                              translationid: '',
                              bitposition: '0',
                              name: 'PA_HeatiCircuCurreState',
                              value: 'Standby',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionOne',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctOne',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctOne',
                              unit: '',
                              translationid: 'TI_FunctionOne',
                              bitposition: '4',
                              name: 'PA_FunctOne',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionTwo',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctTwo',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctTwo',
                              unit: '',
                              translationid: 'TI_FunctionTwo',
                              bitposition: '5',
                              name: 'PA_FunctTwo',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionThree',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctThree',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctThree',
                              unit: '',
                              translationid: 'TI_Level',
                              bitposition: '6',
                              name: 'PA_FunctThree',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionFour',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctFour',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne/PA_FunctFour',
                              unit: '',
                              translationid: 'TI_Mode',
                              bitposition: '7',
                              name: 'PA_FunctFour',
                              value: 'No',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuOne',
                          unit: '',
                          translationid: 'TI_HeatingCircuitOne',
                          bitposition: '0',
                          name: 'PA_HeatiCircuOne',
                          value: '5',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'HeatingCircuitTwo',
                          byteposition: '7',
                          dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_HeatiCircuTwo',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitCurrentState',
                              byteposition: '0',
                              dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                              precision: '',
                              byteLength: '4',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuCurreState',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Standby',
                                  interval: '0',
                                  texttableentry: 'Standby',
                                },
                                {
                                  TI_texttableentry: 'TI_Reduced',
                                  interval: '1',
                                  texttableentry: 'Reduced',
                                },
                                {
                                  TI_texttableentry: 'TI_Normal',
                                  interval: '2',
                                  texttableentry: 'Normal',
                                },
                                {
                                  TI_texttableentry: 'TI_Comfort',
                                  interval: '3',
                                  texttableentry: 'Comfort',
                                },
                                {
                                  TI_texttableentry: 'TI_FixValue',
                                  interval: '4',
                                  texttableentry: 'FixValue',
                                },
                                {
                                  TI_texttableentry: 'TI_FrostProtection',
                                  interval: '5',
                                  texttableentry: 'FrostProtection',
                                },
                                {
                                  TI_texttableentry: 'TI_ReducedEnergySaving',
                                  interval: '6',
                                  texttableentry: 'ReducedEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_NormalEnergySaving',
                                  interval: '7',
                                  texttableentry: 'NormalEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_ComfortEnergySaving',
                                  interval: '8',
                                  texttableentry: 'ComfortEnergySaving',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_HeatiCircuCurreState',
                              unit: '',
                              translationid: '',
                              bitposition: '0',
                              name: 'PA_HeatiCircuCurreState',
                              value: 'Standby',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionOne',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctOne',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctOne',
                              unit: '',
                              translationid: 'TI_FunctionOne',
                              bitposition: '4',
                              name: 'PA_FunctOne',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionTwo',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctTwo',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctTwo',
                              unit: '',
                              translationid: 'TI_FunctionTwo',
                              bitposition: '5',
                              name: 'PA_FunctTwo',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionThree',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctThree',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctThree',
                              unit: '',
                              translationid: 'TI_Level',
                              bitposition: '6',
                              name: 'PA_FunctThree',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionFour',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctFour',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo/PA_FunctFour',
                              unit: '',
                              translationid: 'TI_Mode',
                              bitposition: '7',
                              name: 'PA_FunctFour',
                              value: 'No',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuTwo',
                          unit: '',
                          translationid: 'TI_HeatingCircuitTwo',
                          bitposition: '0',
                          name: 'PA_HeatiCircuTwo',
                          value: '5',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'HeatingCircuitThree',
                          byteposition: '8',
                          dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_HeatiCircuThree',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitCurrentState',
                              byteposition: '0',
                              dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                              precision: '',
                              byteLength: '4',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuCurreState',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Standby',
                                  interval: '0',
                                  texttableentry: 'Standby',
                                },
                                {
                                  TI_texttableentry: 'TI_Reduced',
                                  interval: '1',
                                  texttableentry: 'Reduced',
                                },
                                {
                                  TI_texttableentry: 'TI_Normal',
                                  interval: '2',
                                  texttableentry: 'Normal',
                                },
                                {
                                  TI_texttableentry: 'TI_Comfort',
                                  interval: '3',
                                  texttableentry: 'Comfort',
                                },
                                {
                                  TI_texttableentry: 'TI_FixValue',
                                  interval: '4',
                                  texttableentry: 'FixValue',
                                },
                                {
                                  TI_texttableentry: 'TI_FrostProtection',
                                  interval: '5',
                                  texttableentry: 'FrostProtection',
                                },
                                {
                                  TI_texttableentry: 'TI_ReducedEnergySaving',
                                  interval: '6',
                                  texttableentry: 'ReducedEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_NormalEnergySaving',
                                  interval: '7',
                                  texttableentry: 'NormalEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_ComfortEnergySaving',
                                  interval: '8',
                                  texttableentry: 'ComfortEnergySaving',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_HeatiCircuCurreState',
                              unit: '',
                              translationid: '',
                              bitposition: '0',
                              name: 'PA_HeatiCircuCurreState',
                              value: 'Standby',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionOne',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctOne',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctOne',
                              unit: '',
                              translationid: 'TI_FunctionOne',
                              bitposition: '4',
                              name: 'PA_FunctOne',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionTwo',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctTwo',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctTwo',
                              unit: '',
                              translationid: 'TI_FunctionTwo',
                              bitposition: '5',
                              name: 'PA_FunctTwo',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionThree',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctThree',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctThree',
                              unit: '',
                              translationid: 'TI_Level',
                              bitposition: '6',
                              name: 'PA_FunctThree',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionFour',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctFour',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree/PA_FunctFour',
                              unit: '',
                              translationid: 'TI_Mode',
                              bitposition: '7',
                              name: 'PA_FunctFour',
                              value: 'No',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuThree',
                          unit: '',
                          translationid: 'TI_HeatingCircuitThree',
                          bitposition: '0',
                          name: 'PA_HeatiCircuThree',
                          value: '5',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'HeatingCircuitFour',
                          byteposition: '9',
                          dopname: '8 Bit Structure HeatingCircuitModeLevelFunction',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_HeatiCircuFour',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'HeatingCircuitCurrentState',
                              byteposition: '0',
                              dopname: '4 Bit TextTable uint8 FreezeFrameOperationState',
                              precision: '',
                              byteLength: '4',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_HeatiCircuCurreState',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Standby',
                                  interval: '0',
                                  texttableentry: 'Standby',
                                },
                                {
                                  TI_texttableentry: 'TI_Reduced',
                                  interval: '1',
                                  texttableentry: 'Reduced',
                                },
                                {
                                  TI_texttableentry: 'TI_Normal',
                                  interval: '2',
                                  texttableentry: 'Normal',
                                },
                                {
                                  TI_texttableentry: 'TI_Comfort',
                                  interval: '3',
                                  texttableentry: 'Comfort',
                                },
                                {
                                  TI_texttableentry: 'TI_FixValue',
                                  interval: '4',
                                  texttableentry: 'FixValue',
                                },
                                {
                                  TI_texttableentry: 'TI_FrostProtection',
                                  interval: '5',
                                  texttableentry: 'FrostProtection',
                                },
                                {
                                  TI_texttableentry: 'TI_ReducedEnergySaving',
                                  interval: '6',
                                  texttableentry: 'ReducedEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_NormalEnergySaving',
                                  interval: '7',
                                  texttableentry: 'NormalEnergySaving',
                                },
                                {
                                  TI_texttableentry: 'TI_ComfortEnergySaving',
                                  interval: '8',
                                  texttableentry: 'ComfortEnergySaving',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_HeatiCircuCurreState',
                              unit: '',
                              translationid: '',
                              bitposition: '0',
                              name: 'PA_HeatiCircuCurreState',
                              value: 'Standby',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionOne',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctOne',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctOne',
                              unit: '',
                              translationid: 'TI_FunctionOne',
                              bitposition: '4',
                              name: 'PA_FunctOne',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionTwo',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctTwo',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctTwo',
                              unit: '',
                              translationid: 'TI_FunctionTwo',
                              bitposition: '5',
                              name: 'PA_FunctTwo',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionThree',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctThree',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctThree',
                              unit: '',
                              translationid: 'TI_Level',
                              bitposition: '6',
                              name: 'PA_FunctThree',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'FunctionFour',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_FunctFour',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour/PA_FunctFour',
                              unit: '',
                              translationid: 'TI_Mode',
                              bitposition: '7',
                              name: 'PA_FunctFour',
                              value: 'No',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_HeatiCircuFour',
                          unit: '',
                          translationid: 'TI_HeatingCircuitFour',
                          bitposition: '0',
                          name: 'PA_HeatiCircuFour',
                          value: '5',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'DomesticHotWater',
                          byteposition: '10',
                          dopname: '8 Bit Structure DomesticHotWater',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_DomesHotWater',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'Mode',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_Mode',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Mode',
                              unit: '',
                              translationid: 'TI_Mode',
                              bitposition: '0',
                              name: 'PA_Mode',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'LegionellaActive',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_LegioActiv',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_LegioActiv',
                              unit: '',
                              translationid: 'TI_LegionellaActive',
                              bitposition: '1',
                              name: 'PA_LegioActiv',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'CirculationPump',
                              byteposition: '0',
                              dopname: '1 Bit TextTable OffOn',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_CircuPump',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Off',
                                  interval: '0',
                                  texttableentry: 'Off',
                                },
                                {
                                  TI_texttableentry: 'TI_On',
                                  interval: '1',
                                  texttableentry: 'On',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_CircuPump',
                              unit: '',
                              translationid: 'TI_CirculationPump',
                              bitposition: '2',
                              name: 'PA_CircuPump',
                              value: 'Off',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'DomesticHotWaterActive',
                              byteposition: '0',
                              dopname: '1 Bit TextTable OffOn',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_DomesHotWaterActiv',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Off',
                                  interval: '0',
                                  texttableentry: 'Off',
                                },
                                {
                                  TI_texttableentry: 'TI_On',
                                  interval: '1',
                                  texttableentry: 'On',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_DomesHotWaterActiv',
                              unit: '',
                              translationid: 'TI_FunctionTwo',
                              bitposition: '3',
                              name: 'PA_DomesHotWaterActiv',
                              value: 'Off',
                            },
                            {
                              semantic: 'RESERVED',
                              longname: 'Reserved',
                              byteposition: '0',
                              dopname: '',
                              precision: '',
                              byteLength: '4',
                              type: 'eA_UINT32',
                              shortname: 'PA_Reser',
                              constraints: '',
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater/PA_Reser',
                              unit: '',
                              translationid: '',
                              bitposition: '4',
                              name: 'PA_Reser',
                              value: '0',
                            },
                          ],
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWater',
                          unit: '',
                          translationid: 'TI_DomesticHotWater',
                          bitposition: '0',
                          name: 'PA_DomesHotWater',
                          value: '5',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'Solar',
                          byteposition: '11',
                          dopname: '8 Bit Structure Solar',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_Solar',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'VALUE',
                              longname: 'Mode',
                              byteposition: '0',
                              dopname: '1 Bit TextTable NoYes',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_Mode',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_No',
                                  interval: '0',
                                  texttableentry: 'No',
                                },
                                {
                                  TI_texttableentry: 'TI_Yes',
                                  interval: '1',
                                  texttableentry: 'Yes',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Mode',
                              unit: '',
                              translationid: 'TI_Mode',
                              bitposition: '0',
                              name: 'PA_Mode',
                              value: 'No',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'PumpActive',
                              byteposition: '0',
                              dopname: '1 Bit TextTable OffOn',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_PumpActiv',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Off',
                                  interval: '0',
                                  texttableentry: 'Off',
                                },
                                {
                                  TI_texttableentry: 'TI_On',
                                  interval: '1',
                                  texttableentry: 'On',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_PumpActiv',
                              unit: '',
                              translationid: 'TI_PumpActive',
                              bitposition: '1',
                              name: 'PA_PumpActiv',
                              value: 'Off',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'SuppressionDomesticHotWater',
                              byteposition: '0',
                              dopname: '1 Bit TextTable OffOn',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_SupprDomesHotWater',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Off',
                                  interval: '0',
                                  texttableentry: 'Off',
                                },
                                {
                                  TI_texttableentry: 'TI_On',
                                  interval: '1',
                                  texttableentry: 'On',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprDomesHotWater',
                              unit: '',
                              translationid: 'TI_SuppressionDomesticHotWater',
                              bitposition: '2',
                              name: 'PA_SupprDomesHotWater',
                              value: 'Off',
                            },
                            {
                              semantic: 'VALUE',
                              longname: 'SuppressionCentralHeating',
                              byteposition: '0',
                              dopname: '1 Bit TextTable OffOn',
                              precision: '',
                              byteLength: '1',
                              type: 'eTEXTTABLE',
                              shortname: 'PA_SupprCentrHeati',
                              constraints: '',
                              structure: [
                                {
                                  TI_texttableentry: 'TI_Off',
                                  interval: '0',
                                  texttableentry: 'Off',
                                },
                                {
                                  TI_texttableentry: 'TI_On',
                                  interval: '1',
                                  texttableentry: 'On',
                                },
                              ],
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_SupprCentrHeati',
                              unit: '',
                              translationid: 'TI_SuppressionCentralHeating',
                              bitposition: '3',
                              name: 'PA_SupprCentrHeati',
                              value: 'Off',
                            },
                            {
                              semantic: 'RESERVED',
                              longname: 'Reserved',
                              byteposition: '0',
                              dopname: '',
                              precision: '',
                              byteLength: '4',
                              type: 'eA_UINT32',
                              shortname: 'PA_Reser',
                              constraints: '',
                              path:
                                'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar/PA_Reser',
                              unit: '',
                              translationid: '',
                              bitposition: '4',
                              name: 'PA_Reser',
                              value: '0',
                            },
                          ],
                          path: 'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_Solar',
                          unit: '',
                          translationid: 'TI_Solar',
                          bitposition: '0',
                          name: 'PA_Solar',
                          value: '5',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'FlowTemperatureSensor',
                          byteposition: '12',
                          dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                          precision: '1',
                          byteLength: '16',
                          type: 'eA_FLOAT32',
                          shortname: 'PA_FlowTempeSenso',
                          constraints: '[-3276.8:3276.7]',
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_FlowTempeSenso',
                          unit: '°C',
                          translationid: 'TI_FlowTemperatureSensor',
                          bitposition: '0',
                          name: 'PA_FlowTempeSenso',
                          value: '0.0',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'OutsideTemperatureSensor',
                          byteposition: '14',
                          dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                          precision: '1',
                          byteLength: '16',
                          type: 'eA_FLOAT32',
                          shortname: 'PA_OutsiTempeSenso',
                          constraints: '[-3276.8:3276.7]',
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_OutsiTempeSenso',
                          unit: '°C',
                          translationid: 'TI_OutsideTemperatureSensor',
                          bitposition: '0',
                          name: 'PA_OutsiTempeSenso',
                          value: '0.0',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'DomesticHotWaterTemperatureSensor',
                          byteposition: '16',
                          dopname: '2 Byte Linear int16 Divided 10 Precision 1 Degree Celsius',
                          precision: '1',
                          byteLength: '16',
                          type: 'eA_FLOAT32',
                          shortname: 'PA_DomesHotWaterTempeSenso',
                          constraints: '[-3276.8:3276.7]',
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_DomesHotWaterTempeSenso',
                          unit: '°C',
                          translationid: 'TI_DomesticHotWaterTemperatureSensor',
                          bitposition: '0',
                          name: 'PA_DomesHotWaterTempeSenso',
                          value: '0.0',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'PrimaryCircuitPumpSpeed',
                          byteposition: '18',
                          dopname: '1 Byte Identical uint8 Percent',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_PrimaCircuPumpSpeed',
                          constraints: '[0:255]',
                          path:
                            'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu/PA_PrimaCircuPumpSpeed',
                          unit: '%',
                          translationid: 'TI_PrimaryCircuitPumpSpeed',
                          bitposition: '0',
                          name: 'PA_PrimaCircuPumpSpeed',
                          value: '0',
                        },
                      ],
                      path: 'PA_Struc/PA_FreezFrame/STR_StrucFreezFrameGenerHmu',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_StrucFreezFrameGenerHmu',
                      value: '17',
                    },
                  ],
                  path: 'PA_Struc/PA_FreezFrame',
                  unit: '',
                  translationid: 'TI_FreezeFrame',
                  bitposition: '0',
                  name: 'PA_FreezFrame',
                  value: '1',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
